export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: number; output: number; }
  StreamRequest: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AcceptTeamMemberInvitationInputs = {
  invitationCode: Scalars['String']['input'];
};

export type AcceptTeamMemberInvitationMutationResponse = MutationResponse & {
  __typename?: 'AcceptTeamMemberInvitationMutationResponse';
  code: Scalars['String']['output'];
  invitation?: Maybe<UserInvitation>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AcceptUserTermsMutationResponse = MutationResponse & {
  __typename?: 'AcceptUserTermsMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ActiveBulkGenerateTakeRun = {
  __typename?: 'ActiveBulkGenerateTakeRun';
  createdAt: Scalars['String']['output'];
  items: Array<ActiveBulkGenerateTakeRunItem>;
  pendingItems: Array<ActiveBulkGenerateTakeRunItem>;
  projectId: Scalars['ID']['output'];
  runId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ActiveBulkGenerateTakeRunInputs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
  runId?: InputMaybe<Scalars['ID']['input']>;
};

export type ActiveBulkGenerateTakeRunItem = {
  __typename?: 'ActiveBulkGenerateTakeRunItem';
  avatarId: Scalars['Int']['output'];
  avatarVariantId: Scalars['Int']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  formattedText: Scalars['String']['output'];
  sectionId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  takeId?: Maybe<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
  ttsVersion: Scalars['String']['output'];
};

export type Actor = {
  __typename?: 'Actor';
  accessLevel?: Maybe<ActorAccessLevel>;
  availableIn?: Maybe<SubscriptionTier>;
  /** @deprecated Unused by all clients. Scheduled for removal. */
  description: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  initials: Scalars['String']['output'];
  isBusiness?: Maybe<Scalars['Boolean']['output']>;
  isCustomActor?: Maybe<Scalars['Boolean']['output']>;
  isEnterprise?: Maybe<Scalars['Boolean']['output']>;
  isPartnerVoice?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `ActorVariant.locale`. */
  locale?: Maybe<Locale>;
  name: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  /** @deprecated Unused by all clients. Scheduled for removal. */
  previewText: Scalars['String']['output'];
  /**
   * Indicates possible subscription upgrades in order to access actor. Relates to availableIn field.
   * @deprecated Unused by all clients. Scheduled for removal.
   */
  restrictionTags?: Maybe<Array<SubscriptionTier>>;
  tags?: Maybe<Array<AvatarTaggingAttribute>>;
  variants: Array<ActorVariant>;
};

export enum ActorAccessLevel {
  Locked = 'LOCKED',
  Read = 'READ'
}

export type ActorVariant = {
  __typename?: 'ActorVariant';
  id: Scalars['Int']['output'];
  /** An archived variant will no longer show up in-studio */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isBeta?: Maybe<Scalars['Boolean']['output']>;
  locale: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<AvatarTaggingAttribute>>;
  teamSettings?: Maybe<TeamAvatarSettings>;
  userSettings?: Maybe<UserAvatarSettings>;
  variantType: ActorVariantType;
  /** Will always be equivalent to the latest model version */
  version: Scalars['String']['output'];
  /** A map of all the model versions available for a variant. These will frequently be updated as new versions of the model are released. */
  versions: ActorVariantVersions;
};

export type ActorVariantType = {
  __typename?: 'ActorVariantType';
  description?: Maybe<Scalars['String']['output']>;
  id: ActorVariantTypeId;
  label: Scalars['String']['output'];
};

export enum ActorVariantTypeId {
  Casual = 'CASUAL',
  Character = 'CHARACTER',
  Conversational = 'CONVERSATIONAL',
  Custom = 'CUSTOM',
  CustomV2 = 'CUSTOM_V2',
  Narration = 'NARRATION',
  Promo = 'PROMO'
}

export type ActorVariantVersions = {
  __typename?: 'ActorVariantVersions';
  latest: TtsModelRelease;
  next?: Maybe<TtsModelRelease>;
  preview?: Maybe<TtsModelRelease>;
  previous?: Maybe<TtsModelRelease>;
};

export type AddOnFeature = {
  __typename?: 'AddOnFeature';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
  valueType: AddOnFeatureValueType;
};

export enum AddOnFeatureValueType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER'
}

export type AddOnPurchasePreview = {
  __typename?: 'AddOnPurchasePreview';
  amountDue: Scalars['Int']['output'];
  nextBillingAmount: Scalars['Int']['output'];
  nextBillingDate: Scalars['Int']['output'];
  prorationDate: Scalars['Int']['output'];
  tax?: Maybe<Scalars['Int']['output']>;
};

export type AddTeamMemberInputs = {
  email?: InputMaybe<Scalars['String']['input']>;
  role: TeamRole;
  teamId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddTeamMemberMutationResponse = MutationResponse & {
  __typename?: 'AddTeamMemberMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  teamMember?: Maybe<TeamMember>;
};

export type AddTeamSeatsRequestInputs = {
  formContext?: InputMaybe<HubSpotFormContext>;
  seatCount: Scalars['Int']['input'];
  teamId: Scalars['ID']['input'];
};

export type AddTeamSeatsRequestMutationResponse = MutationResponse & {
  __typename?: 'AddTeamSeatsRequestMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AddressInfo = {
  __typename?: 'AddressInfo';
  shipping?: Maybe<Shipping>;
  taxId?: Maybe<TaxId>;
};

export type AddressInfoInputs = {
  shipping?: InputMaybe<ShippingInput>;
  taxId?: InputMaybe<TaxIdInput>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Admin = {
  __typename?: 'Admin';
  teamUserRoles: Array<TeamUserRole>;
};


export type AdminTeamUserRolesArgs = {
  inputs: AdminTeamInputs;
};

export type AdminTeamInputs = {
  teamId: Scalars['String']['input'];
};

export type AncestorFolder = {
  __typename?: 'AncestorFolder';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
};

export type Announcement = {
  __typename?: 'Announcement';
  announcementCta?: Maybe<AnnouncementCta>;
  announcementIntervals?: Maybe<Array<AnnouncementInterval>>;
  dismissable: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type AnnouncementCta = {
  __typename?: 'AnnouncementCta';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AnnouncementInterval = {
  __typename?: 'AnnouncementInterval';
  end: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  start: Scalars['String']['output'];
};

export type ApiSubscription = {
  __typename?: 'ApiSubscription';
  apiKey: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  endingAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pausedAt?: Maybe<Scalars['String']['output']>;
  planName: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['String']['output']>;
  startingAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum AudioFileFormat {
  Mp3 = 'mp3',
  Ogg = 'ogg',
  Wav = 'wav'
}

export enum AudioPlaybackSetting {
  Continuous = 'Continuous',
  SingleSection = 'SingleSection'
}

export enum AvatarOrderByOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC'
}

export type AvatarTaggingAttribute = {
  __typename?: 'AvatarTaggingAttribute';
  attribute: Scalars['String']['output'];
  category: AvatarTaggingAttributeCategoryEnum;
  internalTag: Scalars['Boolean']['output'];
};

export enum AvatarTaggingAttributeCategoryEnum {
  Age = 'AGE',
  Beta = 'BETA',
  Custom = 'CUSTOM',
  Featured = 'FEATURED',
  Gender = 'GENDER',
  New = 'NEW',
  PerformanceStyles = 'PERFORMANCE_STYLES',
  Recommended = 'RECOMMENDED',
  RegionalAccents = 'REGIONAL_ACCENTS',
  Testing = 'TESTING',
  VoiceCharacteristics = 'VOICE_CHARACTERISTICS'
}

export type BaseClip = {
  actorId: Scalars['ID']['output'];
  actorVariantId: Scalars['ID']['output'];
  audioFormat: Scalars['String']['output'];
  combinedFrom?: Maybe<Array<Scalars['ID']['output']>>;
  createdAt: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  isComplete: Scalars['Boolean']['output'];
  isCreditableBy?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  sequence: Scalars['String']['output'];
  src: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textFormat?: Maybe<Scalars['String']['output']>;
  ttsVersion?: Maybe<Scalars['String']['output']>;
};

export type BaseClipType = BaseClip & {
  __typename?: 'BaseClipType';
  actorId: Scalars['ID']['output'];
  actorVariantId: Scalars['ID']['output'];
  audioFormat: Scalars['String']['output'];
  combinedFrom?: Maybe<Array<Scalars['ID']['output']>>;
  createdAt: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  isComplete: Scalars['Boolean']['output'];
  isCreditableBy?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  sequence: Scalars['String']['output'];
  src: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textFormat?: Maybe<Scalars['String']['output']>;
  ttsVersion?: Maybe<Scalars['String']['output']>;
};

export type BaseProject = {
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  creatorId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BillingHistory = {
  __typename?: 'BillingHistory';
  date: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** if invoice has not been finalized, pdf will be null; undefined for subscriptions */
  pdf?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: BillingHistoryType;
};

export enum BillingHistoryType {
  Invoice = 'INVOICE'
}

export type BillingSource = {
  __typename?: 'BillingSource';
  brand: Scalars['String']['output'];
  expiry: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type BulkCreateEntitlementFeatureInputs = {
  entitlementFeatures: Array<EntitlementFeatureInput>;
};

export type BulkCreateEntitlementFeatureMutationResponse = MutationResponse & {
  __typename?: 'BulkCreateEntitlementFeatureMutationResponse';
  code: Scalars['String']['output'];
  entitlementFeatures?: Maybe<Array<EntitlementFeature>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkCreateEntitlementInputs = {
  entitlements: Array<CreateEntitlementInputs>;
};

export type BulkCreateEntitlementMutationResponse = MutationResponse & {
  __typename?: 'BulkCreateEntitlementMutationResponse';
  code: Scalars['String']['output'];
  entitlements?: Maybe<Array<Entitlement>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkCreateFeatureInputs = {
  features: Array<CreateFeatureInputs>;
};

export type BulkCreateFeatureMutationResponse = MutationResponse & {
  __typename?: 'BulkCreateFeatureMutationResponse';
  code: Scalars['String']['output'];
  features?: Maybe<Array<Feature>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkCreateSectionsInputs = {
  existingSectionSequence?: InputMaybe<Scalars['String']['input']>;
  sections: Array<CreateSectionInputs>;
};

export type BulkCreateSectionsMutationResponse = MutationResponse & {
  __typename?: 'BulkCreateSectionsMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  sections?: Maybe<Array<Section>>;
  success: Scalars['Boolean']['output'];
};

export type BulkCreateTeamUserRoleInputs = {
  teamUserRoles: Array<CreateTeamUserRoleInputs>;
};

export type BulkCreateTeamUserRoleMutationResponse = MutationResponse & {
  __typename?: 'BulkCreateTeamUserRoleMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  teamUserRoles?: Maybe<Array<TeamUserRole>>;
};

export type BulkCreateTeamUserRolePermissionInputs = {
  teamUserRolePermissions: Array<CreateTeamUserRolePermissionInputs>;
};

export type BulkCreateTeamUserRolePermissionMutationResponse = MutationResponse & {
  __typename?: 'BulkCreateTeamUserRolePermissionMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  teamUserRolePermissions?: Maybe<Array<TeamUserRolePermission>>;
};

export type BulkDeleteSectionsInputs = {
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeleteSectionsMutationResponse = MutationResponse & {
  __typename?: 'BulkDeleteSectionsMutationResponse';
  affectedRows?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkGenerateTakeRunItemInput = {
  avatarId: Scalars['Int']['input'];
  avatarVariantId: Scalars['Int']['input'];
  /** Stable editor schema; persisted to takes.editor when provided. */
  editor?: InputMaybe<Scalars['String']['input']>;
  /** TTS egress format (converted from editor when provided). */
  formattedText?: InputMaybe<Scalars['String']['input']>;
  projectVersion?: InputMaybe<Scalars['String']['input']>;
  sampleRate?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  ttsVersion: Scalars['String']['input'];
};

export type BulkRunItemChangedEvent = {
  __typename?: 'BulkRunItemChangedEvent';
  bulkRunItemId: Scalars['ID']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  runId: Scalars['ID']['output'];
  sectionId: Scalars['ID']['output'];
  status: BulkRunItemChangedStatus;
  takeId?: Maybe<Scalars['ID']['output']>;
};

export enum BulkRunItemChangedStatus {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export type BulkRunItemChangedSubscriptionInputs = {
  projectId: Scalars['ID']['input'];
};

export type BulkRunStartedEvent = {
  __typename?: 'BulkRunStartedEvent';
  projectId: Scalars['ID']['output'];
  runId: Scalars['ID']['output'];
};

export type BulkRunStartedSubscriptionInputs = {
  projectId: Scalars['ID']['input'];
};

export type BulkUpdateEntitlementInputs = {
  /** When true with syncEntitlementFeatures, returns a preview plan without writing. */
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  entitlements: Array<UpdateEntitlementInputs>;
  /**
   * When true, syncs entitlement feature links to match each row's featureIds.
   * Links not in the list are removed; missing links are added.
   */
  syncEntitlementFeatures?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkUpdateEntitlementMutationResponse = MutationResponse & {
  __typename?: 'BulkUpdateEntitlementMutationResponse';
  code: Scalars['String']['output'];
  entitlements?: Maybe<Array<Entitlement>>;
  /** Populated when inputs.debug is true with syncEntitlementFeatures. */
  featureSyncPlan?: Maybe<EntitlementFeatureSyncPlan>;
  message: Scalars['String']['output'];
  planErrors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type BulkUpdateSectionPauseInputs = {
  defaultPauseLength?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['String']['input'];
  sectionPauses: Array<SectionPause>;
};

export type BulkUpdateSectionPauseMutationResponse = MutationResponse & {
  __typename?: 'BulkUpdateSectionPauseMutationResponse';
  code: Scalars['String']['output'];
  defaultPauseLength?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkUpdateSectionSequenceInputs = {
  followingSectionId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<Scalars['ID']['input']>;
  precedingSectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkUpdateSectionSequenceMutationResponse = MutationResponse & {
  __typename?: 'BulkUpdateSectionSequenceMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  sections?: Maybe<Array<Section>>;
  success: Scalars['Boolean']['output'];
};

export type BulkUpdateSectionsInputs = {
  sections: Array<UpdateSectionInputs>;
};

export type BulkUpdateSectionsMutationResponse = MutationResponse & {
  __typename?: 'BulkUpdateSectionsMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  sections?: Maybe<Array<Section>>;
  success: Scalars['Boolean']['output'];
};

export type CalculateTaxInputs = {
  addressInfo: AddressInfoInputs;
  amount: Scalars['Int']['input'];
};

export type CancelAddOnInputs = {
  addOnId: Scalars['ID']['input'];
};

export type CancelAddOnMutationResponse = MutationResponse & {
  __typename?: 'CancelAddOnMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<UserSubscription>;
  success: Scalars['Boolean']['output'];
};

export type CancelBulkGenerateTakeRunInputs = {
  runId: Scalars['ID']['input'];
};

export type CancelBulkGenerateTakeRunMutationResponse = MutationResponse & {
  __typename?: 'CancelBulkGenerateTakeRunMutationResponse';
  canceled: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChangeProjectAccessEvent = {
  __typename?: 'ChangeProjectAccessEvent';
  action: ProjectAccessActionEnum;
  projectId: Scalars['String']['output'];
  subject: ProjectAccessChangedSubject;
};

export type ChangeProjectTypeEvent = {
  __typename?: 'ChangeProjectTypeEvent';
  fromType: ProjectTypeEnum;
  projectId: Scalars['String']['output'];
  toType: ProjectTypeEnum;
  uniqueCacheUserIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type Clip = BaseClip & {
  __typename?: 'Clip';
  actor: ClipActor;
  actorId: Scalars['ID']['output'];
  actorVariantId: Scalars['ID']['output'];
  audioFormat: Scalars['String']['output'];
  combinedFrom?: Maybe<Array<Scalars['ID']['output']>>;
  commentCount?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<ClipCommentsConnection>;
  createdAt: Scalars['String']['output'];
  failedWithError?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  isComplete: Scalars['Boolean']['output'];
  isCreditableBy?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  localSrc?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  project: Project;
  projectId: Scalars['ID']['output'];
  sequence: Scalars['String']['output'];
  src: Scalars['String']['output'];
  streamRequest?: Maybe<Scalars['StreamRequest']['output']>;
  text: Scalars['String']['output'];
  textFormat?: Maybe<Scalars['String']['output']>;
  ttsVersion?: Maybe<Scalars['String']['output']>;
  unviewedCommentCount?: Maybe<Scalars['Int']['output']>;
  wasReCredited?: Maybe<Scalars['Boolean']['output']>;
};

export type ClipActor = {
  __typename?: 'ClipActor';
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  initials: Scalars['String']['output'];
  isCustomActor?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  ttsVersion?: Maybe<Scalars['String']['output']>;
  variant: ActorVariant;
};

export type ClipComment = Comment & {
  __typename?: 'ClipComment';
  clipId?: Maybe<Scalars['ID']['output']>;
  commentViews?: Maybe<Array<CommentView>>;
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sectionId?: Maybe<Scalars['ID']['output']>;
  selfViewed: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type ClipCommentEdge = Edge & {
  __typename?: 'ClipCommentEdge';
  cursor: Scalars['String']['output'];
  node: ClipComment;
};

export type ClipCommentsConnection = Connection & {
  __typename?: 'ClipCommentsConnection';
  edges: Array<ClipCommentEdge>;
  pageInfo: PageInfo;
};

export type ClipEntityChangedEvent = EntityChangedEvent & {
  __typename?: 'ClipEntityChangedEvent';
  changeType: EntityChangeType;
  clipEntity?: Maybe<SubscriptionClip>;
  clipId: Scalars['String']['output'];
  eventTime: Scalars['String']['output'];
  previousProjectId?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['String']['output'];
};

export type ClipEntityChangedSubscriptionInputs = {
  projectId: Scalars['String']['input'];
};

export type ClipsConnection = Connection & {
  __typename?: 'ClipsConnection';
  edges: Array<ClipsEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type ClipsEdge = Edge & {
  __typename?: 'ClipsEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Array<ClipsSearchResultHighlights>>;
  node: Clip;
};

export type ClipsMetrics = {
  __typename?: 'ClipsMetrics';
  totalRendered: Scalars['Int']['output'];
  totalRenderedByActorId: Scalars['Int']['output'];
};


export type ClipsMetricsTotalRenderedByActorIdArgs = {
  inputs: ClipsMetricsTotalRenderedByActorIdInputs;
};

export type ClipsMetricsTotalRenderedByActorIdInputs = {
  actorId: Scalars['ID']['input'];
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClipsSearchResultHighlights = SearchResultHighlights & {
  __typename?: 'ClipsSearchResultHighlights';
  fieldName: Scalars['String']['output'];
  highlight: Scalars['String']['output'];
};

export type CombineClipsInputs = {
  clipIds: Array<Scalars['ID']['input']>;
  combinedClipDisplayName: Scalars['String']['input'];
  msGapDuration: Scalars['Int']['input'];
};

export type CombineClipsMutationResponse = MutationResponse & {
  __typename?: 'CombineClipsMutationResponse';
  baseClip?: Maybe<BaseClipType>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CombineSizeLimitExceeded = {
  __typename?: 'CombineSizeLimitExceeded';
  combinedFileSizeBytes: Scalars['Int']['output'];
  sizeLimitBytes: Scalars['Int']['output'];
};

export type Comment = {
  clipId?: Maybe<Scalars['ID']['output']>;
  commentViews?: Maybe<Array<CommentView>>;
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sectionId?: Maybe<Scalars['ID']['output']>;
  selfViewed: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type CommentView = {
  __typename?: 'CommentView';
  userId: Scalars['ID']['output'];
  viewed: Scalars['Boolean']['output'];
  viewedAt: Scalars['String']['output'];
};

export type Connection = {
  pageInfo?: Maybe<PageInfo>;
};

export enum ConnectionDisplay {
  Auth0 = 'auth0',
  Google = 'google',
  Linkedin = 'linkedin',
  Microsoft = 'microsoft',
  Sso = 'sso'
}

export type ContentTile = {
  __typename?: 'ContentTile';
  audioFile?: Maybe<Scalars['String']['output']>;
  badge?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  cta: ContentTileCta;
  heading: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  location: ContentTileLocation;
  type: ContentTileType;
};

export type ContentTileCta = {
  __typename?: 'ContentTileCTA';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum ContentTileLocation {
  LeftRail = 'leftRail',
  Resources = 'resources'
}

export enum ContentTileType {
  Share = 'share',
  Tip = 'tip',
  Watch = 'watch'
}

export type CopyClipsToProjectInputs = {
  clipIds: Array<Scalars['String']['input']>;
  destinationProjectId: Scalars['String']['input'];
};

export type CopyClipsToProjectMutationResponse = MutationResponse & {
  __typename?: 'CopyClipsToProjectMutationResponse';
  clips?: Maybe<Array<Clip>>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  teamProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  userProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
};

export type Coupon = {
  __typename?: 'Coupon';
  amountOff?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Int']['output']>;
};

export type CreateAudioAccessTokenInputs = {
  takeId: Scalars['ID']['input'];
};

export type CreateAudioAccessTokenMutationResponse = MutationResponse & {
  __typename?: 'CreateAudioAccessTokenMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateClipCommentInputs = {
  clipId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type CreateClipCommentMutationResponse = MutationResponse & {
  __typename?: 'CreateClipCommentMutationResponse';
  code: Scalars['String']['output'];
  comment?: Maybe<ClipComment>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateClipInputs = {
  clipId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  speakerId: Scalars['String']['input'];
  speakerVariantId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  textFormat?: InputMaybe<Scalars['String']['input']>;
  ttsVersion: Scalars['String']['input'];
};

export type CreateClipMutationResponse = MutationResponse & {
  __typename?: 'CreateClipMutationResponse';
  clip?: Maybe<Clip>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateDriveInputs = {
  color?: InputMaybe<Scalars['String']['input']>;
  driveType: DriveTypeFromDb;
  name: Scalars['String']['input'];
  users?: InputMaybe<Array<DriveUserAccess>>;
};

export type CreateDriveMutationResponse = MutationResponse & {
  __typename?: 'CreateDriveMutationResponse';
  code: Scalars['String']['output'];
  drive?: Maybe<UserDrive>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateEntitlementInputs = {
  /** Price in cents (Stripe unit_amount). */
  amount?: InputMaybe<Scalars['Int']['input']>;
  dataSource: Scalars['String']['input'];
  dataSourceId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  featureIds?: InputMaybe<Array<Scalars['String']['input']>>;
  interval: Interval;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  isMultiSeat?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<EntitlementStatus>;
  tier?: InputMaybe<EntitlementTier>;
  type: EntitlementType;
};

export type CreateFeatureInputs = {
  dataType: FeatureDataType;
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  interval: Interval;
  isQuota?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreateFolderInputs = {
  ancestorId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  driveId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFolderMutationResponse = MutationResponse & {
  __typename?: 'CreateFolderMutationResponse';
  code: Scalars['String']['output'];
  folder?: Maybe<Folder>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateInvalidDriveProjectData = {
  __typename?: 'CreateInvalidDriveProjectData';
  creatorId?: Maybe<Scalars['String']['output']>;
  driveId?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['String']['output']>;
  projectClientName?: Maybe<Scalars['String']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  studioVersion?: Maybe<StudioProjectVersion>;
};

export type CreateInvalidDriveProjectsMutationResponse = MutationResponse & {
  __typename?: 'CreateInvalidDriveProjectsMutationResponse';
  code: Scalars['String']['output'];
  data?: Maybe<Array<Maybe<CreateInvalidDriveProjectData>>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateInvitationMutationResponse = MutationResponse & {
  __typename?: 'CreateInvitationMutationResponse';
  code: Scalars['String']['output'];
  invitation?: Maybe<UserInvitation>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateProjectInputs = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  driveId?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sampleRate?: InputMaybe<Scalars['Int']['input']>;
  studioVersion?: InputMaybe<StudioProjectVersion>;
};

export type CreateProjectMutationResponse = MutationResponse & {
  __typename?: 'CreateProjectMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  project?: Maybe<Project>;
  success: Scalars['Boolean']['output'];
  teamProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  userProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
};

export type CreateSectionCommentInputs = {
  content: Scalars['String']['input'];
  sectionId: Scalars['ID']['input'];
};

export type CreateSectionCommentMutationResponse = MutationResponse & {
  __typename?: 'CreateSectionCommentMutationResponse';
  code: Scalars['String']['output'];
  comment?: Maybe<SectionComment>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateSectionInputs = {
  defaultAvatarId?: InputMaybe<Scalars['Int']['input']>;
  defaultAvatarVariantId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Model picked for the default variant (e.g. v12); null uses the variant's own
   * version.
   */
  defaultTtsVersion?: InputMaybe<Scalars['String']['input']>;
  /** Stable editor schema; persisted to sections.editor when provided. */
  editor?: InputMaybe<Scalars['String']['input']>;
  followingSectionId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  precedingSectionId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type CreateSectionMutationResponse = MutationResponse & {
  __typename?: 'CreateSectionMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  section?: Maybe<Section>;
  success: Scalars['Boolean']['output'];
};

export type CreateTakeInputs = {
  avatarId: Scalars['Int']['input'];
  avatarVariantId: Scalars['Int']['input'];
  formattedText: Scalars['String']['input'];
  gcsFileName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sampleRate?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['ID']['input'];
  takeId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  ttsVersion: Scalars['String']['input'];
};

export type CreateTakeMutationResponse = MutationResponse & {
  __typename?: 'CreateTakeMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  take?: Maybe<Take>;
};

export type CreateTeamAgentInputs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Defaults to the caller; must be an active human member of the team. */
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Only `producer` is accepted. */
  role?: InputMaybe<TeamRole>;
  teamId: Scalars['ID']['input'];
};

/** Carries the client secret, returned exactly once (R7, KTD20). Do not cache. */
export type CreateTeamAgentPayload = MutationResponse & {
  __typename?: 'CreateTeamAgentPayload';
  agent?: Maybe<TeamAgent>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateTeamUserInvitationInputs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** When true, it'll send an email to the invitee on success. */
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['ID']['input'];
  teamRole: TeamRole;
};

export type CreateTeamUserRoleInputs = {
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  isQuota: Scalars['Boolean']['input'];
};

export type CreateTeamUserRolePermissionInputs = {
  action: PermissionAction;
  feature: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type CreateTeamUserRolePermissionMutationResponse = MutationResponse & {
  __typename?: 'CreateTeamUserRolePermissionMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  teamUserRolePermission?: Maybe<TeamUserRolePermission>;
};

export type CreateUserAuthMethodInputs = {
  email: Scalars['String']['input'];
  identity: Identity;
  userId: Scalars['String']['input'];
};

export type CreateUserAuthMethodMutationResponse = MutationResponse & {
  __typename?: 'CreateUserAuthMethodMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DebugInputs = {
  /** Omit to toggle the current value. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  key: DebugKey;
};

/** Debug switches for WellSaid admins, scoped to the calling user. */
export enum DebugKey {
  /** Section update mutations fail with a debug_error_simulation error. */
  SectionError = 'SECTION_ERROR'
}

export type DebugMutationResponse = MutationResponse & {
  __typename?: 'DebugMutationResponse';
  code: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<DebugKey>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteClipCommentInputs = {
  clipId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
};

export type DeleteClipInputs = {
  clipId: Scalars['ID']['input'];
};

export type DeleteClipMutationResponse = MutationResponse & {
  __typename?: 'DeleteClipMutationResponse';
  clip?: Maybe<Clip>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  teamProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  userProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  wasReCredited?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteClipsInputs = {
  clipIds: Array<Scalars['ID']['input']>;
};

export type DeleteClipsMutationResponse = MutationResponse & {
  __typename?: 'DeleteClipsMutationResponse';
  clips?: Maybe<Array<Maybe<Clip>>>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  numClipsDeleted?: Maybe<Scalars['Int']['output']>;
  numClipsRecredited?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  teamProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  userProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
};

export type DeleteCommentMutationResponse = MutationResponse & {
  __typename?: 'DeleteCommentMutationResponse';
  code: Scalars['String']['output'];
  commentId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteDriveInputs = {
  driveId: Scalars['String']['input'];
};

export type DeleteDriveMutationResponse = MutationResponse & {
  __typename?: 'DeleteDriveMutationResponse';
  code: Scalars['String']['output'];
  driveId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteFolderInputs = {
  folderId: Scalars['String']['input'];
};

export type DeleteFolderMutationResponse = MutationResponse & {
  __typename?: 'DeleteFolderMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteInvitationMutationResponse = MutationResponse & {
  __typename?: 'DeleteInvitationMutationResponse';
  code: Scalars['String']['output'];
  invitation?: Maybe<UserInvitation>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeletePhoneticReplacementMutationResponse = MutationResponse & {
  __typename?: 'DeletePhoneticReplacementMutationResponse';
  code: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteProjectInputs = {
  projectId: Scalars['ID']['input'];
};

export type DeleteProjectMutationResponse = MutationResponse & {
  __typename?: 'DeleteProjectMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  projectId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  teamProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  userProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
};

export type DeleteSectionCommentInputs = {
  commentId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};

export type DeleteSectionInputs = {
  id: Scalars['ID']['input'];
};

export type DeleteSectionMutationResponse = MutationResponse & {
  __typename?: 'DeleteSectionMutationResponse';
  affectedRows?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteTakeInputs = {
  id: Scalars['ID']['input'];
};

export type DeleteTakeMutationResponse = MutationResponse & {
  __typename?: 'DeleteTakeMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  newCurrentTake?: Maybe<Take>;
  success: Scalars['Boolean']['output'];
};

export type DeleteTeamUserInvitationInputs = {
  id: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type Discount = {
  __typename?: 'Discount';
  amount: Scalars['Int']['output'];
  coupon?: Maybe<Coupon>;
};

export type DownloadClipsInputs = {
  audioFileFormat: AudioFileFormat;
  clientTimeZone?: InputMaybe<Scalars['String']['input']>;
  clipIds: Array<Scalars['String']['input']>;
  includeScriptFormats?: InputMaybe<Array<ScriptFormat>>;
};

export type DownloadClipsMutationResponse = MutationResponse & {
  __typename?: 'DownloadClipsMutationResponse';
  code: Scalars['String']['output'];
  combineSizeLimitExceeded?: Maybe<CombineSizeLimitExceeded>;
  data?: Maybe<DownloadData>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DownloadData = {
  __typename?: 'DownloadData';
  downloadMetricsMetadata: DownloadMetricsMetadata;
  fileFormat: DownloadFileFormat;
  friendlyFileName: Scalars['String']['output'];
  gcsFileName: Scalars['String']['output'];
  signedURL: Scalars['String']['output'];
};

export enum DownloadFileFormat {
  Mp3 = 'mp3',
  Ogg = 'ogg',
  Wav = 'wav',
  Zip = 'zip'
}

export type DownloadMetricsMetadata = {
  __typename?: 'DownloadMetricsMetadata';
  combinedTextLength: Scalars['Int']['output'];
  numberOfClips: Scalars['Int']['output'];
  numberOfClipsJustConverted: Scalars['Int']['output'];
  zipFileAlreadyExisted?: Maybe<Scalars['Boolean']['output']>;
};

export type DownloadProjectClipsInputs = {
  audioFileFormat: AudioFileFormat;
  clientTimeZone?: InputMaybe<Scalars['String']['input']>;
  includeScriptFormats?: InputMaybe<Array<ScriptFormat>>;
  projectId: Scalars['ID']['input'];
};

export type DownloadProjectTakesInputs = {
  audioFileFormat: AudioFileFormat;
  filename?: InputMaybe<Scalars['String']['input']>;
  includeProjectName?: InputMaybe<Scalars['Boolean']['input']>;
  includeScriptFormats?: InputMaybe<Array<ScriptFormat>>;
  msGapDuration?: InputMaybe<Scalars['Int']['input']>;
  numberFilesAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['String']['input'];
};

export type DownloadProjectTakesMutationResponse = MutationResponse & {
  __typename?: 'DownloadProjectTakesMutationResponse';
  code: Scalars['String']['output'];
  combineSizeLimitExceeded?: Maybe<CombineSizeLimitExceeded>;
  data?: Maybe<DownloadData>;
  integrationType?: Maybe<UserIntegrationType>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DownloadTakesInputs = {
  audioFileFormat: AudioFileFormat;
  filename?: InputMaybe<Scalars['String']['input']>;
  includeProjectName?: InputMaybe<Scalars['Boolean']['input']>;
  includeScriptFormats?: InputMaybe<Array<ScriptFormat>>;
  msGapDuration?: InputMaybe<Scalars['Int']['input']>;
  numberFilesAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['String']['input'];
  takeIds: Array<Scalars['String']['input']>;
};

export type DownloadTakesMutationResponse = MutationResponse & {
  __typename?: 'DownloadTakesMutationResponse';
  code: Scalars['String']['output'];
  combineSizeLimitExceeded?: Maybe<CombineSizeLimitExceeded>;
  data?: Maybe<DownloadData>;
  integrationType?: Maybe<UserIntegrationType>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Drive = {
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  driveAccess: DriveAccessRole;
  driveType: DriveTypeFromDb;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  settings?: Maybe<DriveSettings>;
  teamId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type DriveAccessRole = {
  __typename?: 'DriveAccessRole';
  role: DriveAccessRoleEnum;
};

export enum DriveAccessRoleEnum {
  Editor = 'editor',
  FullAccess = 'full_access',
  ReadOnly = 'read_only'
}

export type DriveSettings = {
  __typename?: 'DriveSettings';
  color?: Maybe<Scalars['String']['output']>;
};

export enum DriveTypeFromDb {
  Custom = 'custom',
  Personal = 'personal',
  Team = 'team'
}

export type DriveUser = {
  __typename?: 'DriveUser';
  id: Scalars['ID']['output'];
  role: DriveAccessRoleEnum;
};

export type DriveUserAccess = {
  role?: InputMaybe<DriveAccessRoleEnum>;
  userId: Scalars['String']['input'];
};

export type DrivesInputs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type Edge = {
  cursor?: Maybe<Scalars['String']['output']>;
};

export type EmailValidationResult = {
  acceptAll: Scalars['Boolean']['input'];
  disposable: Scalars['Boolean']['input'];
  free: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
  result: Scalars['String']['input'];
  role: Scalars['Boolean']['input'];
  sendexScore: Scalars['Float']['input'];
};

export type Entitlement = {
  __typename?: 'Entitlement';
  /** Price in cents (Stripe unit_amount). */
  amount?: Maybe<Scalars['Int']['output']>;
  dataSource?: Maybe<Scalars['String']['output']>;
  dataSourceId?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  features: Array<Feature>;
  id: Scalars['ID']['output'];
  interval: Interval;
  isManaged: Scalars['Boolean']['output'];
  isMultiSeat: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: EntitlementStatus;
  tier?: Maybe<EntitlementTier>;
  type: EntitlementType;
};

export type EntitlementFeature = {
  __typename?: 'EntitlementFeature';
  entitlementId: Scalars['String']['output'];
  featureIds: Array<Scalars['String']['output']>;
};

export type EntitlementFeatureInput = {
  entitlementId: Scalars['String']['input'];
  featureIds: Array<Scalars['String']['input']>;
};

/** Dry-run snapshot for entitlement feature sync (debug: true only). */
export type EntitlementFeatureSyncPlan = {
  __typename?: 'EntitlementFeatureSyncPlan';
  errors: Array<Scalars['String']['output']>;
  previews: Array<EntitlementFeatureSyncPreview>;
  snapshotType: Scalars['String']['output'];
};

export type EntitlementFeatureSyncPreview = {
  __typename?: 'EntitlementFeatureSyncPreview';
  dataSourceId: Scalars['String']['output'];
  entitlementId: Scalars['String']['output'];
  errors: Array<Scalars['String']['output']>;
  featureIdsToAdd: Array<Scalars['String']['output']>;
  featureIdsToRemove: Array<Scalars['String']['output']>;
  unchangedFeatureIds: Array<Scalars['String']['output']>;
};

export type EntitlementPromotionCounts = {
  __typename?: 'EntitlementPromotionCounts';
  created: Scalars['Int']['output'];
  deprecated: Scalars['Int']['output'];
  phasedOut: Scalars['Int']['output'];
  promotedToCurrent: Scalars['Int']['output'];
};

/** Per tier:interval key — mirrors EntitlementPromotionKeyPlan. */
export type EntitlementPromotionKeyPlan = {
  __typename?: 'EntitlementPromotionKeyPlan';
  key: Scalars['String']['output'];
  toBeta?: Maybe<EntitlementPromotionPlanEntry>;
  toCurrent?: Maybe<EntitlementPromotionPlanEntry>;
  toDeprecated?: Maybe<EntitlementPromotionPlanEntry>;
  toPhasingOut?: Maybe<EntitlementPromotionPlanEntry>;
};

/** Dry-run snapshot from getPromotionPlanSnapshot (debug: true only). */
export type EntitlementPromotionPlan = {
  __typename?: 'EntitlementPromotionPlan';
  errors: Array<Scalars['String']['output']>;
  planned: Array<EntitlementPromotionKeyPlan>;
  promotionSet: Array<Scalars['String']['output']>;
  snapshotType: Scalars['String']['output'];
};

export enum EntitlementPromotionPlanAction {
  Create = 'create',
  UpdateStatus = 'update_status'
}

/** One planned create or status transition (dry-run / debug). */
export type EntitlementPromotionPlanEntry = {
  __typename?: 'EntitlementPromotionPlanEntry';
  action: EntitlementPromotionPlanAction;
  dataSource?: Maybe<Scalars['String']['output']>;
  dataSourceId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  featureIds?: Maybe<Array<Scalars['String']['output']>>;
  fromStatus?: Maybe<EntitlementStatus>;
  id?: Maybe<Scalars['ID']['output']>;
  interval?: Maybe<Interval>;
  isManaged?: Maybe<Scalars['Boolean']['output']>;
  isMultiSeat?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EntitlementStatus>;
  tier?: Maybe<EntitlementTier>;
  toStatus?: Maybe<EntitlementStatus>;
  type?: Maybe<EntitlementType>;
};

export enum EntitlementStatus {
  Beta = 'beta',
  Current = 'current',
  Deprecated = 'deprecated',
  PhasingOut = 'phasing_out'
}

export enum EntitlementTier {
  Business = 'business',
  Creative = 'creative',
  Designer = 'designer',
  Enterprise = 'enterprise',
  Maker = 'maker',
  Producer = 'producer',
  Trial = 'trial'
}

export enum EntitlementType {
  StudioAddOn = 'studio_add_on',
  StudioTier = 'studio_tier'
}

export enum EntityChangeType {
  Created = 'Created',
  Deleted = 'Deleted',
  Updated = 'Updated'
}

export type EntityChangedEvent = {
  changeType: EntityChangeType;
};

export type Feature = {
  __typename?: 'Feature';
  dataType: FeatureDataType;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: Interval;
  isQuota: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum FeatureDataType {
  Auth0Role = 'auth0_role',
  Boolean = 'boolean',
  Number = 'number',
  String = 'string'
}

export type FilterAndSearchAvatarsInputs = {
  accessLevel?: InputMaybe<ActorAccessLevel>;
  filters?: InputMaybe<Array<FilterAvatarsInput>>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamVoice?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<AvatarOrderByOrder>;
  projectVersion?: InputMaybe<StudioProjectVersion>;
  randomize?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type FilterAvatarsInput = {
  attribute: Scalars['String']['input'];
  category: AvatarTaggingAttributeCategoryEnum;
};

export type Folder = {
  __typename?: 'Folder';
  createdAt: Scalars['String']['output'];
  creatorId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  driveId?: Maybe<Scalars['String']['output']>;
  folderCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectCount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type FolderFilters = {
  driveId?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
};

export type FolderHierarchy = {
  __typename?: 'FolderHierarchy';
  children: Array<Folder>;
  parent: Folder;
};

export type FolderInputs = {
  driveId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<FolderFilters>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ProjectsOrderBy>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GetChangePasswordLinkMutationResponse = MutationResponse & {
  __typename?: 'GetChangePasswordLinkMutationResponse';
  code: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetClipCommentsInputs = {
  clipId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetDriveInputs = {
  driveId: Scalars['String']['input'];
};

export type GetFoldersInputs = {
  folderId: Scalars['String']['input'];
};

export type GetSectionCommentsInputs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['ID']['input'];
};

export type GetSectionsInputs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
};

export type GetSharedSectionsInputs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetTakesInputs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['ID']['input'];
};

export type HubSpotFormContext = {
  pageName?: InputMaybe<Scalars['String']['input']>;
  pageUri?: InputMaybe<Scalars['String']['input']>;
};

export type Identity = {
  connection: Scalars['String']['input'];
  isSocial: Scalars['Boolean']['input'];
  profileData?: InputMaybe<ProfileData>;
  provider: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type ImportPhoneticLibraryInputs = {
  importBehavior: ImportPhoneticLibraryOptions;
};

export type ImportPhoneticLibraryInputsV2 = {
  libraryType?: InputMaybe<PhoneticLibraryType>;
};

export type ImportPhoneticLibraryMutationResponse = MutationResponse & {
  __typename?: 'ImportPhoneticLibraryMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ImportPhoneticLibraryMutationResponseV2 = MutationResponse & {
  __typename?: 'ImportPhoneticLibraryMutationResponseV2';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  newEntries?: Maybe<Array<Maybe<PhoneticReplacement>>>;
  success: Scalars['Boolean']['output'];
};

export enum ImportPhoneticLibraryOptions {
  ReplaceAll = 'replaceAll',
  ReplaceDuplicates = 'replaceDuplicates',
  ReplaceNone = 'replaceNone'
}

export enum Interval {
  Day = 'day',
  Month = 'month',
  Perpetual = 'perpetual',
  Week = 'week',
  Year = 'year'
}

export type LlmPronunciationSuggestion = {
  __typename?: 'LlmPronunciationSuggestion';
  pronunciation: Scalars['String']['output'];
};

export type LlmPronunciationSuggestionContext = {
  script: Scalars['String']['input'];
  wordEndIndex: Scalars['Int']['input'];
  wordStartIndex: Scalars['Int']['input'];
};

export type LlmPronunciationSuggestionInputs = {
  context?: InputMaybe<LlmPronunciationSuggestionContext>;
  word: Scalars['String']['input'];
};

export type LlmPronunciationSuggestionResponse = MutationResponse & {
  __typename?: 'LlmPronunciationSuggestionResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  suggestions: Array<LlmPronunciationSuggestion>;
};

export type LlmRephraseSuggestionContext = {
  script: Scalars['String']['input'];
  wordEndIndex: Scalars['Int']['input'];
  wordStartIndex: Scalars['Int']['input'];
};

export type LlmRephraseSuggestionInputs = {
  context?: InputMaybe<LlmRephraseSuggestionContext>;
  word: Scalars['String']['input'];
};

export type LlmRephraseSuggestionResponse = MutationResponse & {
  __typename?: 'LlmRephraseSuggestionResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type LlmTranslationContext = {
  sourceLanguage: Scalars['String']['input'];
  targetLanguage: Scalars['String']['input'];
};

export type LlmTranslationInputs = {
  context: LlmTranslationContext;
  scripts: Array<Scalars['String']['input']>;
};

export type LlmTranslationResponse = MutationResponse & {
  __typename?: 'LlmTranslationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  results?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type LlmVoiceAuditionInputs = {
  message: Scalars['String']['input'];
};

export type LlmVoiceAuditionResponse = MutationResponse & {
  __typename?: 'LlmVoiceAuditionResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  results?: Maybe<LlmVoiceAuditionResults>;
  success: Scalars['Boolean']['output'];
};

export type LlmVoiceAuditionResults = {
  __typename?: 'LlmVoiceAuditionResults';
  sampleText: Scalars['String']['output'];
  topMatches: LlmVoiceMatchResponse;
  youMayAlsoLike: LlmVoiceMatchResponse;
};

export type LlmVoiceMatch = {
  __typename?: 'LlmVoiceMatch';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  rationale: Scalars['String']['output'];
};

export type LlmVoiceMatchResponse = {
  __typename?: 'LlmVoiceMatchResponse';
  reason: Scalars['String']['output'];
  voices: Array<LlmVoiceMatch>;
};

export enum Locale {
  Au = 'AU',
  Br = 'BR',
  Ca = 'CA',
  De = 'DE',
  Fr = 'FR',
  Gb = 'GB',
  Ie = 'IE',
  Mx = 'MX',
  Uk = 'UK',
  Us = 'US',
  Za = 'ZA'
}

export type MarkAllClipCommentsAsViewedInputs = {
  clipId: Scalars['ID']['input'];
};

export type MarkAllCommentsAsViewedMutationResponse = MutationResponse & {
  __typename?: 'MarkAllCommentsAsViewedMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MarkAllSectionCommentsAsViewedInputs = {
  sectionId: Scalars['ID']['input'];
};

export type MarkClipCommentAsUnviewedInputs = {
  clipId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
};

export type MarkClipCommentAsViewedInputs = {
  clipId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
};

export type MarkCommentAsUnviewedMutationResponse = MutationResponse & {
  __typename?: 'MarkCommentAsUnviewedMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MarkCommentAsViewedMutationResponse = MutationResponse & {
  __typename?: 'MarkCommentAsViewedMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MarkSectionCommentAsUnviewedInputs = {
  commentId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};

export type MarkSectionCommentAsViewedInputs = {
  commentId: Scalars['ID']['input'];
  sectionId: Scalars['ID']['input'];
};

export type MigrateProjectInputs = {
  projectId: Scalars['ID']['input'];
};

export type MigrateProjectMutationResponse = MutationResponse & {
  __typename?: 'MigrateProjectMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  projectId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MoveClipsToProjectInputs = {
  clipIds: Array<Scalars['String']['input']>;
  clipIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
  clipSequences?: InputMaybe<Array<Scalars['String']['input']>>;
  destinationProjectId: Scalars['String']['input'];
};

export type MoveClipsToProjectMutationResponse = MutationResponse & {
  __typename?: 'MoveClipsToProjectMutationResponse';
  clips?: Maybe<Array<Clip>>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MoveFilesInputs = {
  driveId?: InputMaybe<Scalars['String']['input']>;
  folderIds: Array<Scalars['String']['input']>;
  newAncestorId?: InputMaybe<Scalars['String']['input']>;
  projectIds: Array<Scalars['String']['input']>;
};

export type MoveFilesMutationResponse = MutationResponse & {
  __typename?: 'MoveFilesMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MoveFolderInputs = {
  driveId?: InputMaybe<Scalars['String']['input']>;
  folderIds: Array<Scalars['String']['input']>;
  newAncestorId?: InputMaybe<Scalars['String']['input']>;
};

export type MoveFolderMutationResponse = MutationResponse & {
  __typename?: 'MoveFolderMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type MoveProjectInputs = {
  precedingProjectId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTeamMemberInvitation: AcceptTeamMemberInvitationMutationResponse;
  acceptUserTerms: AcceptUserTermsMutationResponse;
  addTeamMember: AddTeamMemberMutationResponse;
  addTeamSeatsRequest: AddTeamSeatsRequestMutationResponse;
  bulkCreateEntitlement: BulkCreateEntitlementMutationResponse;
  bulkCreateEntitlementFeature: BulkCreateEntitlementFeatureMutationResponse;
  bulkCreateFeature: BulkCreateFeatureMutationResponse;
  bulkCreateSections: BulkCreateSectionsMutationResponse;
  bulkCreateTeamUserRole: BulkCreateTeamUserRoleMutationResponse;
  bulkCreateTeamUserRolePermissions: BulkCreateTeamUserRolePermissionMutationResponse;
  bulkDeleteSections: BulkDeleteSectionsMutationResponse;
  bulkUpdateEntitlement: BulkUpdateEntitlementMutationResponse;
  bulkUpdateSectionPause: BulkUpdateSectionPauseMutationResponse;
  bulkUpdateSectionSequence: BulkUpdateSectionSequenceMutationResponse;
  bulkUpdateSections: BulkUpdateSectionsMutationResponse;
  cancelAddOn: CancelAddOnMutationResponse;
  cancelBulkGenerateTakeRun: CancelBulkGenerateTakeRunMutationResponse;
  combineClips: CombineClipsMutationResponse;
  copyClipsToProject: CopyClipsToProjectMutationResponse;
  createAudioAccessToken: CreateAudioAccessTokenMutationResponse;
  createClip: CreateClipMutationResponse;
  createClipComment: CreateClipCommentMutationResponse;
  createDrive: CreateDriveMutationResponse;
  createFolder: CreateFolderMutationResponse;
  createProject: CreateProjectMutationResponse;
  createSection: CreateSectionMutationResponse;
  createSectionComment: CreateSectionCommentMutationResponse;
  createTeamAgent: CreateTeamAgentPayload;
  createTeamUserRolePermission: CreateTeamUserRolePermissionMutationResponse;
  createUserAuthMethod: CreateUserAuthMethodMutationResponse;
  debug: DebugMutationResponse;
  deleteClip: DeleteClipMutationResponse;
  deleteClipComment: DeleteCommentMutationResponse;
  deleteClips: DeleteClipsMutationResponse;
  deleteDrive: DeleteDriveMutationResponse;
  deleteFolder: DeleteFolderMutationResponse;
  deleteProject: DeleteProjectMutationResponse;
  deleteSection: DeleteSectionMutationResponse;
  deleteSectionComment: DeleteCommentMutationResponse;
  deleteTake: DeleteTakeMutationResponse;
  deleteTeamMemberInvitation: DeleteInvitationMutationResponse;
  disableProjectSharing: ProjectSharingDisableMutationResponse;
  downloadClips: DownloadClipsMutationResponse;
  downloadProjectClips: DownloadClipsMutationResponse;
  downloadProjectTakes: DownloadProjectTakesMutationResponse;
  downloadTakes: DownloadTakesMutationResponse;
  enableProjectSharing: ProjectSharingEnableMutationResponse;
  getChangePasswordLink: GetChangePasswordLinkMutationResponse;
  importPhoneticLibrary: ImportPhoneticLibraryMutationResponse;
  importPhoneticLibrary_V2: ImportPhoneticLibraryMutationResponseV2;
  inviteTeamMember: CreateInvitationMutationResponse;
  llmPronunciationSuggestion: LlmPronunciationSuggestionResponse;
  llmRephraseSuggestion: LlmRephraseSuggestionResponse;
  llmTranslation: LlmTranslationResponse;
  llmVoiceAudition: LlmVoiceAuditionResponse;
  markAllClipCommentsAsViewed: MarkAllCommentsAsViewedMutationResponse;
  markAllSectionCommentsAsViewed: MarkAllCommentsAsViewedMutationResponse;
  markClipCommentAsUnviewed: MarkCommentAsUnviewedMutationResponse;
  markClipCommentAsViewed: MarkCommentAsViewedMutationResponse;
  markSectionCommentAsUnviewed: MarkCommentAsUnviewedMutationResponse;
  markSectionCommentAsViewed: MarkCommentAsViewedMutationResponse;
  migrateProject: MigrateProjectMutationResponse;
  moveClipsToProject: MoveClipsToProjectMutationResponse;
  moveFiles: MoveFilesMutationResponse;
  moveFolder: MoveFolderMutationResponse;
  phoneticReplacement: PhoneticReplacement;
  phoneticReplacementCreate: PhoneticReplacementMutationResponse;
  phoneticReplacementDelete: PhoneticReplacement;
  phoneticReplacementDelete_V2: DeletePhoneticReplacementMutationResponse;
  phoneticReplacementUpdate: PhoneticReplacementMutationResponse;
  /** @deprecated Causes duplicate and spam account data generation */
  preSignupEmailValidation: PreSignupEmailValidationMutationResponse;
  promoteEntitlements: PromoteEntitlementsMutationResponse;
  purchaseAddOn: PurchaseAddOnMutationResponse;
  removeTeamAgent: RemoveTeamAgentPayload;
  removeTeamMember: RemoveTeamMemberMutationResponse;
  renameFolder: RenameFolderMutationResponse;
  renameProject: UpdateProjectMutationResponse;
  reorderClip: ReorderClipMutationResponse;
  requestApiKey?: Maybe<RequestApiKeyMutationResponse>;
  requestCancelClipRendering: RequestCancelClipRenderingMutationResponse;
  requestCancelTakeRendering: RequestCancelClipRenderingMutationResponse;
  resendTeamMemberInvitation: ResendTeamMemberInvitationMutationResponse;
  restoreClip: RestoreClipMutationResponse;
  restoreClips: RestoreClipsMutationResponse;
  rotateTeamAgentSecret: RotateTeamAgentSecretPayload;
  sendVerificationEmail: SendVerificationEmailMutationResponse;
  setCurrentTake: SetCurrentTakeMutationResponse;
  setProjectReplacements: SetProjectReplacementsMutationResponse;
  setTeamAgentEnabled: SetTeamAgentEnabledPayload;
  startBulkGenerateTakeRun: StartBulkGenerateTakeRunMutationResponse;
  submitTakeFeedback: SubmitTakeFeedbackMutationResponse;
  tokenizeScript: TokenizeScriptMutationResponse;
  translateProject: TranslateProjectResponse;
  undoCancelAddOn: UndoCancelAddOnMutationResponse;
  updateAddressInfo: UpdateAddressInfoMutationResponse;
  updateClip: UpdateClipMutationResponse;
  updateClipComment: UpdateClipCommentMutationResponse;
  updateDrive: UpdateDriveMutationResponse;
  updateDriveUsers: UpdateDriveUsersMutationResponse;
  updatePaymentSource: UpdatePaymentSourceMutationResponse;
  updateProjectAccessBulkTeamMemberAccessRole: UpdateProjectAccessBulkTeamMemberAccessResponse;
  updateProjectAccessTeamMemberAccessRole: UpdateProjectAccessTeamMemberAccessResponse;
  updateProjectAccessTeamWideAccessRole: UpdateProjectAccessTeamWideAccessResponse;
  updateProjectDefaultPauseLength: UpdateProjectDefaultPauseLengthResponse;
  updateProjectVoices: UpdateProjectVoicesMutationResponse;
  updateSection: UpdateSectionMutationResponse;
  updateSectionComment: UpdateSectionCommentMutationResponse;
  updateSectionName: UpdateSectionNameMutationResponse;
  updateSectionSequence: UpdateSectionSequenceMutationResponse;
  updateSectionVoice: UpdateSectionVoiceMutationResponse;
  updateSectionVoices: UpdateSectionVoicesMutationResponse;
  updateTeamAgent: UpdateTeamAgentPayload;
  updateTeamAvatarSettings?: Maybe<UpdateTeamAvatarSettingsMutationResponse>;
  updateTeamMember: UpdateTeamMemberMutationResponse;
  updateTeamMemberInvitation: UpdateInvitationMutationResponse;
  updateTeamSettings: UpdateTeamSettingsResponse;
  updateUserAuthMethods: UpdateUserAuthMethodsMutationResponse;
  updateUserAvatarSettings?: Maybe<UpdateUserAvatarSettingsMutationResponse>;
  updateUserProfile: UpdateUserProfileMutationResponse;
  updateUserSelections: UpdateUserSelectionsResponse;
  updateUserSettings: UpdateUserSettingsResponse;
  userSubscriptionCancel: UserSubscriptionCancelMutationRespnse;
  userSubscriptionPlanChange: UserSubscriptionPlanChangeMutationResponse;
  userSubscriptionUndoCancellation: UserSubscriptionUndoCancellationMutationResponse;
  userSubscriptionUpgrade: UserSubscriptionUpgradeMutationResponse;
};


export type MutationAcceptTeamMemberInvitationArgs = {
  inputs: AcceptTeamMemberInvitationInputs;
};


export type MutationAddTeamMemberArgs = {
  inputs: AddTeamMemberInputs;
};


export type MutationAddTeamSeatsRequestArgs = {
  inputs: AddTeamSeatsRequestInputs;
};


export type MutationBulkCreateEntitlementArgs = {
  inputs: BulkCreateEntitlementInputs;
};


export type MutationBulkCreateEntitlementFeatureArgs = {
  inputs: BulkCreateEntitlementFeatureInputs;
};


export type MutationBulkCreateFeatureArgs = {
  inputs: BulkCreateFeatureInputs;
};


export type MutationBulkCreateSectionsArgs = {
  inputs: BulkCreateSectionsInputs;
};


export type MutationBulkCreateTeamUserRoleArgs = {
  inputs: BulkCreateTeamUserRoleInputs;
};


export type MutationBulkCreateTeamUserRolePermissionsArgs = {
  inputs: BulkCreateTeamUserRolePermissionInputs;
};


export type MutationBulkDeleteSectionsArgs = {
  inputs: BulkDeleteSectionsInputs;
};


export type MutationBulkUpdateEntitlementArgs = {
  inputs: BulkUpdateEntitlementInputs;
};


export type MutationBulkUpdateSectionPauseArgs = {
  inputs: BulkUpdateSectionPauseInputs;
};


export type MutationBulkUpdateSectionSequenceArgs = {
  inputs: BulkUpdateSectionSequenceInputs;
};


export type MutationBulkUpdateSectionsArgs = {
  inputs: BulkUpdateSectionsInputs;
};


export type MutationCancelAddOnArgs = {
  inputs: CancelAddOnInputs;
};


export type MutationCancelBulkGenerateTakeRunArgs = {
  inputs: CancelBulkGenerateTakeRunInputs;
};


export type MutationCombineClipsArgs = {
  inputs: CombineClipsInputs;
};


export type MutationCopyClipsToProjectArgs = {
  inputs?: InputMaybe<CopyClipsToProjectInputs>;
};


export type MutationCreateAudioAccessTokenArgs = {
  inputs: CreateAudioAccessTokenInputs;
};


export type MutationCreateClipArgs = {
  inputs: CreateClipInputs;
};


export type MutationCreateClipCommentArgs = {
  inputs: CreateClipCommentInputs;
};


export type MutationCreateDriveArgs = {
  inputs?: InputMaybe<CreateDriveInputs>;
};


export type MutationCreateFolderArgs = {
  inputs: CreateFolderInputs;
};


export type MutationCreateProjectArgs = {
  inputs: CreateProjectInputs;
};


export type MutationCreateSectionArgs = {
  inputs: CreateSectionInputs;
};


export type MutationCreateSectionCommentArgs = {
  inputs: CreateSectionCommentInputs;
};


export type MutationCreateTeamAgentArgs = {
  inputs: CreateTeamAgentInputs;
};


export type MutationCreateTeamUserRolePermissionArgs = {
  inputs: CreateTeamUserRolePermissionInputs;
};


export type MutationCreateUserAuthMethodArgs = {
  inputs: CreateUserAuthMethodInputs;
};


export type MutationDebugArgs = {
  inputs: DebugInputs;
};


export type MutationDeleteClipArgs = {
  inputs: DeleteClipInputs;
};


export type MutationDeleteClipCommentArgs = {
  inputs: DeleteClipCommentInputs;
};


export type MutationDeleteClipsArgs = {
  inputs: DeleteClipsInputs;
};


export type MutationDeleteDriveArgs = {
  inputs?: InputMaybe<DeleteDriveInputs>;
};


export type MutationDeleteFolderArgs = {
  inputs: DeleteFolderInputs;
};


export type MutationDeleteProjectArgs = {
  inputs: DeleteProjectInputs;
};


export type MutationDeleteSectionArgs = {
  inputs: DeleteSectionInputs;
};


export type MutationDeleteSectionCommentArgs = {
  inputs: DeleteSectionCommentInputs;
};


export type MutationDeleteTakeArgs = {
  inputs: DeleteTakeInputs;
};


export type MutationDeleteTeamMemberInvitationArgs = {
  inputs: DeleteTeamUserInvitationInputs;
};


export type MutationDisableProjectSharingArgs = {
  inputs: ProjectSharingDisableInputs;
};


export type MutationDownloadClipsArgs = {
  inputs: DownloadClipsInputs;
};


export type MutationDownloadProjectClipsArgs = {
  inputs: DownloadProjectClipsInputs;
};


export type MutationDownloadProjectTakesArgs = {
  inputs: DownloadProjectTakesInputs;
};


export type MutationDownloadTakesArgs = {
  inputs: DownloadTakesInputs;
};


export type MutationEnableProjectSharingArgs = {
  inputs: ProjectSharingEnableInputs;
};


export type MutationImportPhoneticLibraryArgs = {
  file: Scalars['Upload']['input'];
  inputs: ImportPhoneticLibraryInputs;
};


export type MutationImportPhoneticLibrary_V2Args = {
  file: Scalars['Upload']['input'];
  inputs: ImportPhoneticLibraryInputsV2;
};


export type MutationInviteTeamMemberArgs = {
  inputs: CreateTeamUserInvitationInputs;
};


export type MutationLlmPronunciationSuggestionArgs = {
  inputs: LlmPronunciationSuggestionInputs;
};


export type MutationLlmRephraseSuggestionArgs = {
  inputs: LlmRephraseSuggestionInputs;
};


export type MutationLlmTranslationArgs = {
  inputs: LlmTranslationInputs;
};


export type MutationLlmVoiceAuditionArgs = {
  inputs: LlmVoiceAuditionInputs;
};


export type MutationMarkAllClipCommentsAsViewedArgs = {
  inputs: MarkAllClipCommentsAsViewedInputs;
};


export type MutationMarkAllSectionCommentsAsViewedArgs = {
  inputs: MarkAllSectionCommentsAsViewedInputs;
};


export type MutationMarkClipCommentAsUnviewedArgs = {
  inputs: MarkClipCommentAsUnviewedInputs;
};


export type MutationMarkClipCommentAsViewedArgs = {
  inputs: MarkClipCommentAsViewedInputs;
};


export type MutationMarkSectionCommentAsUnviewedArgs = {
  inputs: MarkSectionCommentAsUnviewedInputs;
};


export type MutationMarkSectionCommentAsViewedArgs = {
  inputs: MarkSectionCommentAsViewedInputs;
};


export type MutationMigrateProjectArgs = {
  inputs: MigrateProjectInputs;
};


export type MutationMoveClipsToProjectArgs = {
  inputs: MoveClipsToProjectInputs;
};


export type MutationMoveFilesArgs = {
  inputs: MoveFilesInputs;
};


export type MutationMoveFolderArgs = {
  inputs: MoveFolderInputs;
};


export type MutationPhoneticReplacementArgs = {
  inputs: PhoneticReplacementInputs;
};


export type MutationPhoneticReplacementCreateArgs = {
  inputs: PhoneticReplacementInputs;
};


export type MutationPhoneticReplacementDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPhoneticReplacementDelete_V2Args = {
  id: Scalars['ID']['input'];
};


export type MutationPhoneticReplacementUpdateArgs = {
  inputs: PhoneticReplacementInputs;
};


export type MutationPreSignupEmailValidationArgs = {
  inputs: PreSignupEmailValidationInputs;
};


export type MutationPromoteEntitlementsArgs = {
  inputs: PromoteEntitlementsInputs;
};


export type MutationPurchaseAddOnArgs = {
  inputs: PurchaseAddOnInputs;
};


export type MutationRemoveTeamAgentArgs = {
  inputs: RemoveTeamAgentInputs;
};


export type MutationRemoveTeamMemberArgs = {
  inputs: RemoveTeamMemberInputs;
};


export type MutationRenameFolderArgs = {
  inputs: RenameFolderInputs;
};


export type MutationRenameProjectArgs = {
  inputs: RenameProjectInputs;
};


export type MutationReorderClipArgs = {
  inputs: ReorderClipInputs;
};


export type MutationRequestApiKeyArgs = {
  inputs: RequestApiKeyInputs;
};


export type MutationRequestCancelClipRenderingArgs = {
  inputs: RequestCancelClipRenderingInputs;
};


export type MutationRequestCancelTakeRenderingArgs = {
  inputs: RequestCancelTakeRenderingInputs;
};


export type MutationResendTeamMemberInvitationArgs = {
  inputs: ResendTeamMemberInvitationInputs;
};


export type MutationRestoreClipArgs = {
  inputs: RestoreClipInputs;
};


export type MutationRestoreClipsArgs = {
  inputs: RestoreClipsInputs;
};


export type MutationRotateTeamAgentSecretArgs = {
  inputs: RotateTeamAgentSecretInputs;
};


export type MutationSendVerificationEmailArgs = {
  inputs: SendVerificationEmailInputs;
};


export type MutationSetCurrentTakeArgs = {
  inputs: SetCurrentTakeInputs;
};


export type MutationSetProjectReplacementsArgs = {
  inputs: SetProjectReplacementsInputs;
};


export type MutationSetTeamAgentEnabledArgs = {
  inputs: SetTeamAgentEnabledInputs;
};


export type MutationStartBulkGenerateTakeRunArgs = {
  inputs: StartBulkGenerateTakeRunInputs;
};


export type MutationSubmitTakeFeedbackArgs = {
  inputs: SubmitTakeFeedbackInputs;
};


export type MutationTokenizeScriptArgs = {
  inputs: TokenizeScriptInputs;
};


export type MutationTranslateProjectArgs = {
  inputs: TranslateProjectInputs;
};


export type MutationUndoCancelAddOnArgs = {
  inputs: UndoCancelAddOnInputs;
};


export type MutationUpdateAddressInfoArgs = {
  inputs: AddressInfoInputs;
};


export type MutationUpdateClipArgs = {
  inputs: UpdateClipInputs;
};


export type MutationUpdateClipCommentArgs = {
  inputs: UpdateClipCommentInputs;
};


export type MutationUpdateDriveArgs = {
  inputs?: InputMaybe<UpdateDriveInputs>;
};


export type MutationUpdateDriveUsersArgs = {
  inputs?: InputMaybe<UpdateDriveUsersInputs>;
};


export type MutationUpdatePaymentSourceArgs = {
  inputs: UpdatePaymentSourceInputs;
};


export type MutationUpdateProjectAccessBulkTeamMemberAccessRoleArgs = {
  inputs: UpdateBulkTeamMemberAccessInputs;
};


export type MutationUpdateProjectAccessTeamMemberAccessRoleArgs = {
  inputs: UpdateTeamMemberAccessInputs;
};


export type MutationUpdateProjectAccessTeamWideAccessRoleArgs = {
  inputs: UpdateTeamWideAccessInputs;
};


export type MutationUpdateProjectDefaultPauseLengthArgs = {
  inputs: UpdateProjectDefaultPauseLengthInputs;
};


export type MutationUpdateProjectVoicesArgs = {
  inputs: UpdateProjectVoicesInputs;
};


export type MutationUpdateSectionArgs = {
  inputs: UpdateSectionInputs;
};


export type MutationUpdateSectionCommentArgs = {
  inputs: UpdateSectionCommentInputs;
};


export type MutationUpdateSectionNameArgs = {
  inputs: UpdateSectionNameInputs;
};


export type MutationUpdateSectionSequenceArgs = {
  inputs: UpdateSectionSequenceInputs;
};


export type MutationUpdateSectionVoiceArgs = {
  inputs: UpdateSectionVoiceInputs;
};


export type MutationUpdateSectionVoicesArgs = {
  inputs: UpdateSectionVoicesInputs;
};


export type MutationUpdateTeamAgentArgs = {
  inputs: UpdateTeamAgentInputs;
};


export type MutationUpdateTeamAvatarSettingsArgs = {
  inputs: UpdateTeamAvatarSettingsInputs;
};


export type MutationUpdateTeamMemberArgs = {
  inputs: UpdateTeamMemberInputs;
};


export type MutationUpdateTeamMemberInvitationArgs = {
  inputs: UpdateTeamUserInvitationInputs;
};


export type MutationUpdateTeamSettingsArgs = {
  inputs: UpdateTeamSettingsInputs;
};


export type MutationUpdateUserAuthMethodsArgs = {
  inputs: UpdateUserAuthMethodInputs;
};


export type MutationUpdateUserAvatarSettingsArgs = {
  inputs: UpdateUserAvatarSettingsInputs;
};


export type MutationUpdateUserProfileArgs = {
  inputs: UpdateUserProfileInputs;
};


export type MutationUpdateUserSelectionsArgs = {
  inputs: UpdateUserSelectionsInputs;
};


export type MutationUpdateUserSettingsArgs = {
  inputs: UpdateUserSettingsInputs;
};


export type MutationUserSubscriptionPlanChangeArgs = {
  inputs: UserSubscriptionPlanChangeInputs;
};


export type MutationUserSubscriptionUpgradeArgs = {
  inputs: UserSubscriptionUpgradeInputs;
};

export type MutationResponse = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum OrderBy {
  AlphabeticalAsc = 'alphabetical_ASC',
  AlphabeticalDesc = 'alphabetical_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaginatedInputs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  searchInput?: InputMaybe<Scalars['String']['input']>;
};

export type PaginatedResponse = {
  currentPage: Scalars['Int']['output'];
  /** Total number of items, regardless of pagination */
  itemCount: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  orderBy: OrderBy;
  /** Total number of pages available to query */
  pageCount: Scalars['Int']['output'];
  searchInput?: Maybe<Scalars['String']['output']>;
};

export enum PermissionAction {
  Create = 'create',
  Delete = 'delete',
  Read = 'read',
  Update = 'update'
}

export type PhoneticLibrary = {
  __typename?: 'PhoneticLibrary';
  replacement?: Maybe<PhoneticReplacement>;
  replacements?: Maybe<Array<Maybe<PhoneticReplacement>>>;
  replacements_V2?: Maybe<UserReplacements>;
};


export type PhoneticLibraryReplacementArgs = {
  id: Scalars['ID']['input'];
};

export enum PhoneticLibraryType {
  Personal = 'personal',
  Team = 'team'
}

export type PhoneticReplacement = {
  __typename?: 'PhoneticReplacement';
  actorId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isRespelling: Scalars['Boolean']['output'];
  libraryId?: Maybe<Scalars['String']['output']>;
  replacement: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type PhoneticReplacementInputs = {
  actorId?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isRespelling?: InputMaybe<Scalars['Boolean']['input']>;
  libraryType?: InputMaybe<PhoneticLibraryType>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  replacement: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type PhoneticReplacementMutationResponse = MutationResponse & {
  __typename?: 'PhoneticReplacementMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  replacement?: Maybe<PhoneticReplacement>;
  success: Scalars['Boolean']['output'];
};

export type PreSignupEmailValidationInputs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  emailValidationResult?: InputMaybe<EmailValidationResult>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isTeam?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type PreSignupEmailValidationMutationResponse = MutationResponse & {
  __typename?: 'PreSignupEmailValidationMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type PreviewAddOnPurchaseInputs = {
  addOnPlanId: Scalars['ID']['input'];
};

export type ProductAccessLimits = {
  __typename?: 'ProductAccessLimits';
  clipCreditLimit: Scalars['Int']['output'];
  clipGenerationLimit: Scalars['Int']['output'];
  editorCharacterLimit: Scalars['Int']['output'];
  projectsLimit: Scalars['Int']['output'];
  takeCountDownloadLimit?: Maybe<Scalars['Int']['output']>;
  takeCountGenerationLimit?: Maybe<Scalars['Int']['output']>;
  takeDurationMsDownloadLimit?: Maybe<Scalars['BigInt']['output']>;
  takeDurationMsGenerationLimit?: Maybe<Scalars['BigInt']['output']>;
  takeLengthDownloadLimit?: Maybe<Scalars['Int']['output']>;
  takeLengthGenerationLimit?: Maybe<Scalars['Int']['output']>;
};

export type ProductAccessPeriodUsage = {
  __typename?: 'ProductAccessPeriodUsage';
  clipsCredited: Scalars['Int']['output'];
  clipsGenerated: Scalars['Int']['output'];
  downloadedTakesDurationMs: Scalars['BigInt']['output'];
  downloadedTakesTextLength: Scalars['Int']['output'];
  folders: Scalars['Int']['output'];
  generatedTakesDurationMs: Scalars['BigInt']['output'];
  generatedTakesTextLength: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  joinedAt: Scalars['String']['output'];
  lifetimeCharactersRendered: Scalars['Int']['output'];
  periodEnd: Scalars['Int']['output'];
  periodStart: Scalars['Int']['output'];
  projects: Scalars['Int']['output'];
  takesDownloaded: Scalars['Int']['output'];
  takesGenerated: Scalars['Int']['output'];
  usageScope: ProductAccessUsageScope;
  workspaces: Scalars['Int']['output'];
};

export type Profile = {
  __typename?: 'Profile';
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  lastIp?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['String']['output']>;
  loginsCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  teamSize?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  verificationEmailSent: Scalars['Boolean']['output'];
};

export type ProfileData = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneVerified?: InputMaybe<Scalars['Boolean']['input']>;
  requestLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type Project = BaseProject & {
  __typename?: 'Project';
  bulkPauseLength?: Maybe<Scalars['Int']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clipsCount: Scalars['Int']['output'];
  clips_V2: ClipsConnection;
  createdAt: Scalars['String']['output'];
  creator?: Maybe<ProjectCreator>;
  creatorId: Scalars['String']['output'];
  defaultPauseLength?: Maybe<Scalars['Int']['output']>;
  driveId?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectAccess: ProjectAccess;
  replacements?: Maybe<Array<Maybe<PhoneticReplacement>>>;
  rootDriveId?: Maybe<Scalars['String']['output']>;
  sampleRate?: Maybe<Scalars['Int']['output']>;
  sections?: Maybe<Array<Section>>;
  sectionsCount: Scalars['Int']['output'];
  sequence: Scalars['BigInt']['output'];
  shareable?: Maybe<ProjectShareable>;
  shareableUrl?: Maybe<Scalars['String']['output']>;
  sharedSections: SharedSectionsConnection;
  studioVersion: StudioProjectVersion;
  updatedAt: Scalars['String']['output'];
  voices: Array<ProjectVoices>;
};


export type ProjectClips_V2Args = {
  inputs?: InputMaybe<ProjectClipsInputs_V2>;
};


export type ProjectSharedSectionsArgs = {
  inputs?: InputMaybe<GetSharedSectionsInputs>;
};

export type ProjectAccess = {
  __typename?: 'ProjectAccess';
  id: Scalars['ID']['output'];
  teamMemberAccess?: Maybe<Array<TeamMemberAccess>>;
  teamWideAccessRole?: Maybe<ProjectAccessRole>;
  viewerAccessRole?: Maybe<ProjectAccessRole>;
};

export enum ProjectAccessActionEnum {
  Add = 'add',
  Remove = 'remove'
}

export enum ProjectAccessChangedSubject {
  Personal = 'personal',
  Shared = 'shared'
}

export type ProjectAccessEntityChangedEvent = EntityChangedEvent & {
  __typename?: 'ProjectAccessEntityChangedEvent';
  changeType: EntityChangeType;
  eventTime: Scalars['String']['output'];
  projectAccessEntity: SubscriptionProjectAccess;
  projectId: Scalars['String']['output'];
};

export type ProjectAccessRole = {
  __typename?: 'ProjectAccessRole';
  id: ProjectAccessRoleEnum;
  label: Scalars['String']['output'];
  permissions: Scalars['String']['output'];
};

export enum ProjectAccessRoleEnum {
  Editor = 'editor',
  FullAccess = 'full_access',
  PublicReadOnly = 'public_read_only',
  ReadOnly = 'read_only'
}

export type ProjectClipsInputs_V2 = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectClipsOrderBy>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum ProjectClipsOrderBy {
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  CreditedAtDescNullsFirstCreatedAtDesc = 'creditedAt_DESC_NullsFirst_createdAt_DESC',
  CreditedAtDescNullsLastCreatedAtDesc = 'creditedAt_DESC_NullsLast_createdAt_DESC',
  IndexAsc = 'index_ASC',
  IndexDesc = 'index_DESC',
  SequenceAsc = 'sequence_ASC',
  SequenceDesc = 'sequence_DESC'
}

export type ProjectCreator = {
  __typename?: 'ProjectCreator';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProjectEdge = Edge & {
  __typename?: 'ProjectEdge';
  cursor: Scalars['String']['output'];
  node: Project;
};

export type ProjectEntityChangedEvent = EntityChangedEvent & {
  __typename?: 'ProjectEntityChangedEvent';
  changeType: EntityChangeType;
  eventTime: Scalars['String']['output'];
  projectEntity: SubscriptionProject;
  projectId: Scalars['String']['output'];
};

export type ProjectEntityChangedSubscriptionInputs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ProjectTypeEnum>;
};

export type ProjectFilters = {
  driveId?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  studioVersion?: InputMaybe<StudioProjectVersion>;
};

export type ProjectInputs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProjectFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectsOrderBy>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectSearchConnection = {
  __typename?: 'ProjectSearchConnection';
  /** Absent on the last page. Only valid for the search that produced it. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  results: Array<ProjectSearchResult>;
};

export type ProjectSearchInputs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Optional narrowing. A folder includes everything beneath it. */
  driveId?: InputMaybe<Scalars['ID']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  /** Page size. Values above the enforced maximum are clamped, not rejected. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Free text matched against project name and client name. */
  search: Scalars['String']['input'];
};

/**
 * Why a match was returned, strongest first. Ranking is by tier, then by most
 * recently updated within a tier.
 */
export enum ProjectSearchMatchTier {
  Exact = 'EXACT',
  Prefix = 'PREFIX',
  Similar = 'SIMILAR'
}

/**
 * A project matching a search, carrying enough location to tell same-named
 * projects apart.
 *
 * Deliberately not the Project type: that type's field resolvers re-resolve
 * access per row, which would undo the single-round-trip guarantee this query
 * exists to provide. Callers fetch the full project by id when they need it.
 */
export type ProjectSearchResult = {
  __typename?: 'ProjectSearchResult';
  clientName?: Maybe<Scalars['String']['output']>;
  driveId?: Maybe<Scalars['ID']['output']>;
  driveName?: Maybe<Scalars['String']['output']>;
  driveType?: Maybe<Scalars['String']['output']>;
  /** Root folder first, immediate folder last. Empty when not in a folder. */
  folderPath: Array<Scalars['String']['output']>;
  matchTier: ProjectSearchMatchTier;
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  /** True when sharing was the only way this project reached the user. */
  reachedBySharing: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ProjectSectionSpec = {
  __typename?: 'ProjectSectionSpec';
  avatarId: Scalars['Int']['output'];
  avatarVariantId: Scalars['Int']['output'];
  createdAt: Scalars['String']['output'];
  defaultTTSVersion?: Maybe<Scalars['String']['output']>;
  formattedText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  sequence: Scalars['String']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ProjectShareable = {
  __typename?: 'ProjectShareable';
  deletedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ProjectSharingDisableInputs = {
  projectId: Scalars['String']['input'];
};

export type ProjectSharingDisableMutationResponse = MutationResponse & {
  __typename?: 'ProjectSharingDisableMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  project?: Maybe<Project>;
  success: Scalars['Boolean']['output'];
};

export type ProjectSharingEnableInputs = {
  projectId: Scalars['String']['input'];
};

export type ProjectSharingEnableMutationResponse = MutationResponse & {
  __typename?: 'ProjectSharingEnableMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  project?: Maybe<Project>;
  success: Scalars['Boolean']['output'];
};

export type ProjectSpec = {
  __typename?: 'ProjectSpec';
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  creator?: Maybe<Scalars['String']['output']>;
  creatorId: Scalars['String']['output'];
  driveId?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rootDriveId?: Maybe<Scalars['String']['output']>;
  sampleRate?: Maybe<Scalars['Int']['output']>;
  sections: Array<ProjectSectionSpec>;
  sectionsCount: Scalars['Int']['output'];
  sequence: Scalars['BigInt']['output'];
  studioVersion: StudioProjectVersion;
  updatedAt: Scalars['String']['output'];
};

export enum ProjectTypeEnum {
  Personal = 'personal',
  Shared = 'shared',
  Team = 'team'
}

export type ProjectVoices = {
  __typename?: 'ProjectVoices';
  id: Scalars['Int']['output'];
};

export type ProjectsConnection = Connection & {
  __typename?: 'ProjectsConnection';
  edges: Array<ProjectEdge>;
  pageInfo: PageInfo;
};

export enum ProjectsOrderBy {
  ClientNameAsc = 'clientName_ASC',
  ClientNameDesc = 'clientName_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SequenceAsc = 'sequence_ASC',
  SequenceDesc = 'sequence_DESC'
}

/**
 * Beta promotion row — same shape as seed JSON (`entitlements_and_features_beta.json`).
 * `status` is accepted for fixture parity but ignored; apply always targets `current`.
 */
export type PromoteEntitlementPlanInputs = {
  dataSource: Scalars['String']['input'];
  dataSourceId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  featureIds?: InputMaybe<Array<Scalars['String']['input']>>;
  interval: Interval;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  isMultiSeat?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<EntitlementStatus>;
  tier: EntitlementTier;
  type: EntitlementType;
};

export type PromoteEntitlementsInputs = {
  /** When true, returns a dry-run plan (no writes). When false, applies the promotion. */
  debug?: InputMaybe<Scalars['Boolean']['input']>;
  newEntitlements: Array<PromoteEntitlementPlanInputs>;
};

export type PromoteEntitlementsMutationResponse = MutationResponse & {
  __typename?: 'PromoteEntitlementsMutationResponse';
  code: Scalars['String']['output'];
  counts?: Maybe<EntitlementPromotionCounts>;
  message: Scalars['String']['output'];
  /** Populated when inputs.debug is true. */
  plan?: Maybe<EntitlementPromotionPlan>;
  planErrors?: Maybe<Array<Scalars['String']['output']>>;
  promotionSet?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type PurchaseAddOnInputs = {
  addOnPlanId: Scalars['ID']['input'];
  addressInfo?: InputMaybe<AddressInfoInputs>;
  paymentSource?: InputMaybe<Scalars['String']['input']>;
  prorationDate: Scalars['Int']['input'];
};

export type PurchaseAddOnMutationResponse = MutationResponse & {
  __typename?: 'PurchaseAddOnMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<UserSubscription>;
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  activeBulkGenerateTakeRun?: Maybe<ActiveBulkGenerateTakeRun>;
  actors: Array<Actor>;
  admin?: Maybe<Admin>;
  ancestorFolders?: Maybe<Array<AncestorFolder>>;
  availableAddOnPlans: Array<SubscriptionAddOnPlan>;
  avatarTags: Array<AvatarTaggingAttribute>;
  calculateTax: TaxCalculation;
  clipComments: ClipCommentsConnection;
  comments: ClipCommentsConnection;
  contentTiles: Array<ContentTile>;
  drive?: Maybe<UserDrive>;
  driveUsers: Array<DriveUser>;
  entitlements: Array<Entitlement>;
  features: Array<Feature>;
  folder?: Maybe<Folder>;
  previewAddOnPurchase: AddOnPurchasePreview;
  respellingSuggestions: Array<RespellingSuggestion>;
  respellingSuggestionsByRegion: RespellingSuggestionsByRegion;
  section?: Maybe<Section>;
  sectionComments: SectionCommentsConnection;
  sections: SectionsConnection;
  sharedProject?: Maybe<Project>;
  studioRoutes: Array<StudioRoute>;
  subscriptionPlans: Array<SubscriptionPlan>;
  take?: Maybe<Take>;
  takes: TakesConnection;
  teamUserRolePermissions: Array<TeamUserRolePermission>;
  teamUserRoles: Array<TeamUserRole>;
  tutorials: Array<Tutorial>;
  tutorials_v2: Array<Tutorial_V2>;
  user: User;
  userInvitation?: Maybe<UserInvitation>;
};


export type QueryActiveBulkGenerateTakeRunArgs = {
  inputs: ActiveBulkGenerateTakeRunInputs;
};


export type QueryActorsArgs = {
  inputs?: InputMaybe<FilterAndSearchAvatarsInputs>;
};


export type QueryAncestorFoldersArgs = {
  inputs: GetFoldersInputs;
};


export type QueryCalculateTaxArgs = {
  inputs: CalculateTaxInputs;
};


export type QueryClipCommentsArgs = {
  inputs: GetClipCommentsInputs;
};


export type QueryCommentsArgs = {
  inputs: GetClipCommentsInputs;
};


export type QueryDriveArgs = {
  inputs: GetDriveInputs;
};


export type QueryDriveUsersArgs = {
  inputs: GetDriveInputs;
};


export type QueryFolderArgs = {
  inputs: GetFoldersInputs;
};


export type QueryPreviewAddOnPurchaseArgs = {
  inputs: PreviewAddOnPurchaseInputs;
};


export type QueryRespellingSuggestionsArgs = {
  inputs: RespellingSuggestionsInputs;
};


export type QueryRespellingSuggestionsByRegionArgs = {
  inputs: RespellingSuggestionsInputs;
};


export type QuerySectionArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySectionCommentsArgs = {
  inputs: GetSectionCommentsInputs;
};


export type QuerySectionsArgs = {
  inputs: GetSectionsInputs;
};


export type QuerySharedProjectArgs = {
  inputs: SharedProjectInputs;
};


export type QuerySubscriptionPlansArgs = {
  inputs: SubscriptionPlansInputs;
};


export type QueryTakeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTakesArgs = {
  inputs: GetTakesInputs;
};


export type QueryUserInvitationArgs = {
  inputs: UserInvitationInputs;
};

export type RemoveTeamAgentInputs = {
  agentUserId: Scalars['ID']['input'];
  /**
   * Destination for the agent's personal-drive projects, as in removeTeamMember.
   * Give at most one of driveId and newAncestorId.
   */
  driveId?: InputMaybe<Scalars['String']['input']>;
  newAncestorId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
};

export type RemoveTeamAgentPayload = MutationResponse & {
  __typename?: 'RemoveTeamAgentPayload';
  agentUserId?: Maybe<Scalars['ID']['output']>;
  /** False when Auth0 cleanup is left to the reconciliation sweep. */
  auth0CleanupComplete?: Maybe<Scalars['Boolean']['output']>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RemoveTeamMemberInputs = {
  driveId?: InputMaybe<Scalars['String']['input']>;
  newAncestorId?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type RemoveTeamMemberMutationResponse = MutationResponse & {
  __typename?: 'RemoveTeamMemberMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role?: Maybe<TeamRole>;
  success: Scalars['Boolean']['output'];
  teamId?: Maybe<Scalars['ID']['output']>;
  teamMemberId?: Maybe<Scalars['ID']['output']>;
};

export type RenameFolderInputs = {
  description?: InputMaybe<Scalars['String']['input']>;
  folderId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RenameFolderMutationResponse = MutationResponse & {
  __typename?: 'RenameFolderMutationResponse';
  code: Scalars['String']['output'];
  folder?: Maybe<Folder>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RenameProjectInputs = {
  clientName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  sampleRate?: InputMaybe<Scalars['Int']['input']>;
};

export type ReorderClipInputs = {
  clipId: Scalars['ID']['input'];
  precedingClipId?: InputMaybe<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type ReorderClipMutationResponse = MutationResponse & {
  __typename?: 'ReorderClipMutationResponse';
  clip?: Maybe<Clip>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RequestApiKeyInputs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  usageReason: Scalars['String']['input'];
};

export type RequestApiKeyMutationResponse = MutationResponse & {
  __typename?: 'RequestApiKeyMutationResponse';
  apiKey?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RequestCancelClipRenderingInputs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type RequestCancelClipRenderingMutationResponse = MutationResponse & {
  __typename?: 'RequestCancelClipRenderingMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RequestCancelTakeRenderingInputs = {
  id: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type RequestCancelTakeRenderingMutationResponse = MutationResponse & {
  __typename?: 'RequestCancelTakeRenderingMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ResendTeamMemberInvitationInputs = {
  invitationId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

export type ResendTeamMemberInvitationMutationResponse = MutationResponse & {
  __typename?: 'ResendTeamMemberInvitationMutationResponse';
  code: Scalars['String']['output'];
  invitation?: Maybe<UserInvitation>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RestoreClipInputs = {
  clipId: Scalars['ID']['input'];
};

export type RestoreClipMutationResponse = MutationResponse & {
  __typename?: 'RestoreClipMutationResponse';
  clip?: Maybe<Clip>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  teamProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  userProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
};

export type RestoreClipsInputs = {
  clipIds: Array<Scalars['ID']['input']>;
};

export type RestoreClipsMutationResponse = MutationResponse & {
  __typename?: 'RestoreClipsMutationResponse';
  clips?: Maybe<Array<Maybe<Clip>>>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  numClipsRestored?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  teamProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  userProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type RotateTeamAgentSecretInputs = {
  agentUserId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};

/** Carries the new client secret, returned exactly once (R7, KTD20). Do not cache. */
export type RotateTeamAgentSecretPayload = MutationResponse & {
  __typename?: 'RotateTeamAgentSecretPayload';
  agent?: Maybe<TeamAgent>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum ScriptFormat {
  Srt = 'srt',
  Txt = 'txt',
  Vtt = 'vtt'
}

export type SearchResultHighlights = {
  fieldName: Scalars['String']['output'];
  highlight: Scalars['String']['output'];
};

export type Section = {
  __typename?: 'Section';
  commentCount?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<SectionCommentsConnection>;
  createdAt: Scalars['String']['output'];
  currentTake?: Maybe<Take>;
  defaultAvatarId?: Maybe<Scalars['Int']['output']>;
  defaultAvatarVariantId?: Maybe<Scalars['Int']['output']>;
  /**
   * Model picked for the default variant (e.g. v12); null uses the variant's own
   * version.
   */
  defaultTtsVersion?: Maybe<Scalars['String']['output']>;
  /** Stable editor schema (v2); null for legacy sections. */
  editor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pauseAfter?: Maybe<Scalars['Int']['output']>;
  projectId: Scalars['ID']['output'];
  sequence: Scalars['String']['output'];
  unviewedCommentCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

/** What happened to the sections in a sectionsChanged event. */
export enum SectionChangeKind {
  Created = 'CREATED',
  Deleted = 'DELETED',
  /** Section fields changed (e.g. editor text). */
  Edited = 'EDITED',
  /** The section's current take was created, switched or deleted. */
  TakeChanged = 'TAKE_CHANGED'
}

export type SectionComment = Comment & {
  __typename?: 'SectionComment';
  clipId?: Maybe<Scalars['ID']['output']>;
  commentViews?: Maybe<Array<CommentView>>;
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sectionId?: Maybe<Scalars['ID']['output']>;
  selfViewed: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type SectionCommentEdge = Edge & {
  __typename?: 'SectionCommentEdge';
  cursor: Scalars['String']['output'];
  node: SectionComment;
};

export type SectionCommentsConnection = Connection & {
  __typename?: 'SectionCommentsConnection';
  edges: Array<SectionCommentEdge>;
  pageInfo: PageInfo;
};

export type SectionEdge = {
  __typename?: 'SectionEdge';
  cursor: Scalars['String']['output'];
  node: Section;
};

export type SectionPause = {
  pause?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['String']['input'];
};

export type SectionSpecInput = {
  avatarId: Scalars['Int']['input'];
  avatarVariantId: Scalars['Int']['input'];
  defaultTTSVersion?: InputMaybe<Scalars['String']['input']>;
  formattedText: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  sectionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type SectionVoice = {
  defaultAvatarId: Scalars['Int']['input'];
  defaultAvatarVariantId: Scalars['Int']['input'];
  defaultTtsVersion?: InputMaybe<Scalars['String']['input']>;
  sectionIds: Array<Scalars['String']['input']>;
};

/**
 * One operation's changes to a project's sections, e.g. a bulk delete is a
 * single event listing every deleted section.
 */
export type SectionsChangedEvent = {
  __typename?: 'SectionsChangedEvent';
  kind: SectionChangeKind;
  projectId: Scalars['ID']['output'];
  /** Always set, including for DELETED. */
  sectionIds: Array<Scalars['ID']['output']>;
  /** The sections after the change; empty for DELETED. */
  sections: Array<Section>;
};

export type SectionsChangedSubscriptionInputs = {
  projectId: Scalars['ID']['input'];
};

export type SectionsConnection = {
  __typename?: 'SectionsConnection';
  edges: Array<SectionEdge>;
  pageInfo: PageInfo;
};

export type SendVerificationEmailInputs = {
  via?: InputMaybe<Scalars['String']['input']>;
};

export type SendVerificationEmailMutationResponse = MutationResponse & {
  __typename?: 'SendVerificationEmailMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SetCurrentTakeInputs = {
  id: Scalars['ID']['input'];
};

export type SetCurrentTakeMutationResponse = MutationResponse & {
  __typename?: 'SetCurrentTakeMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  take?: Maybe<Take>;
};

export type SetProjectReplacementsInputs = {
  projectId: Scalars['String']['input'];
  replacementIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type SetProjectReplacementsMutationResponse = MutationResponse & {
  __typename?: 'SetProjectReplacementsMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  project: Project;
  success: Scalars['Boolean']['output'];
};

export type SetTeamAgentEnabledInputs = {
  agentUserId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
  teamId: Scalars['ID']['input'];
};

export type SetTeamAgentEnabledPayload = MutationResponse & {
  __typename?: 'SetTeamAgentEnabledPayload';
  agent?: Maybe<TeamAgent>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SharedProjectInputs = {
  shortUrlSegment: Scalars['String']['input'];
};

export type SharedSectionTakeEdge = {
  __typename?: 'SharedSectionTakeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Take>;
};

export type SharedSectionsConnection = {
  __typename?: 'SharedSectionsConnection';
  edges: Array<SharedSectionTakeEdge>;
  pageInfo: PageInfo;
};

export type Shipping = {
  __typename?: 'Shipping';
  address?: Maybe<Address>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ShippingInput = {
  address: AddressInput;
  name: Scalars['String']['input'];
};

export type StartBulkGenerateTakeRunInputs = {
  items: Array<BulkGenerateTakeRunItemInput>;
  projectId: Scalars['ID']['input'];
};

export type StartBulkGenerateTakeRunMutationResponse = MutationResponse & {
  __typename?: 'StartBulkGenerateTakeRunMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  runId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StudioProjectType = {
  __typename?: 'StudioProjectType';
  label: Scalars['String']['output'];
  version: StudioProjectVersion;
};

export enum StudioProjectVersion {
  AzureArabic = 'azure_arabic',
  AzureChinese = 'azure_chinese',
  AzureCzech = 'azure_czech',
  AzureDanish = 'azure_danish',
  AzureDutch = 'azure_dutch',
  AzureFrench = 'azure_french',
  AzureGerman = 'azure_german',
  AzureItalian = 'azure_italian',
  AzureJapanese = 'azure_japanese',
  AzureKorean = 'azure_korean',
  AzurePersian = 'azure_persian',
  AzurePolish = 'azure_polish',
  AzurePortuguese = 'azure_portuguese',
  AzureSpanish = 'azure_spanish',
  AzureSwedish = 'azure_swedish',
  AzureTurkish = 'azure_turkish',
  ExtAdobe = 'ext_adobe',
  ExtCanva = 'ext_canva',
  Legacy = 'legacy',
  ScriptStudio = 'script_studio',
  Universal = 'universal',
  V2 = 'v2'
}

export type StudioRoute = {
  __typename?: 'StudioRoute';
  label: Scalars['String']['output'];
  route: Scalars['String']['output'];
};

export type SubmitTakeFeedbackInputs = {
  categories?: InputMaybe<Array<TakeFeedbackCategory>>;
  feedbackText?: InputMaybe<Scalars['String']['input']>;
  positiveSentiment: Scalars['Boolean']['input'];
  takeId: Scalars['ID']['input'];
};

export type SubmitTakeFeedbackMutationResponse = MutationResponse & {
  __typename?: 'SubmitTakeFeedbackMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  takeFeedback?: Maybe<TakeFeedback>;
};

export type Subscription = {
  __typename?: 'Subscription';
  bulkRunItemChanged: BulkRunItemChangedEvent;
  bulkRunStarted: BulkRunStartedEvent;
  clipEntityChanged: ClipEntityChangedEvent;
  projectAccessChanged: ChangeProjectAccessEvent;
  projectAccessEntityChanged: ProjectAccessEntityChangedEvent;
  projectEntityChanged: ProjectEntityChangedEvent;
  projectTypeChanged: ChangeProjectTypeEvent;
  sectionsChanged: SectionsChangedEvent;
};


export type SubscriptionBulkRunItemChangedArgs = {
  inputs: BulkRunItemChangedSubscriptionInputs;
};


export type SubscriptionBulkRunStartedArgs = {
  inputs: BulkRunStartedSubscriptionInputs;
};


export type SubscriptionClipEntityChangedArgs = {
  inputs: ClipEntityChangedSubscriptionInputs;
};


export type SubscriptionProjectAccessEntityChangedArgs = {
  inputs: ProjectEntityChangedSubscriptionInputs;
};


export type SubscriptionProjectEntityChangedArgs = {
  inputs: ProjectEntityChangedSubscriptionInputs;
};


export type SubscriptionSectionsChangedArgs = {
  inputs: SectionsChangedSubscriptionInputs;
};

export type SubscriptionAddOn = {
  __typename?: 'SubscriptionAddOn';
  endsAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  plan: SubscriptionAddOnPlan;
};

export type SubscriptionAddOnPlan = {
  __typename?: 'SubscriptionAddOnPlan';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  current: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  features: Array<AddOnFeature>;
  id: Scalars['ID']['output'];
  interval: SubscriptionInterval;
  name: Scalars['String']['output'];
  selectable: Scalars['Boolean']['output'];
};

export type SubscriptionBilling = {
  __typename?: 'SubscriptionBilling';
  addressInfo?: Maybe<AddressInfo>;
  source?: Maybe<BillingSource>;
};

export type SubscriptionClip = BaseClip & {
  __typename?: 'SubscriptionClip';
  actor: ClipActor;
  actorId: Scalars['ID']['output'];
  actorVariantId: Scalars['ID']['output'];
  audioFormat: Scalars['String']['output'];
  combinedFrom?: Maybe<Array<Scalars['ID']['output']>>;
  commentCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  isComplete: Scalars['Boolean']['output'];
  isCreditableBy?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  sequence: Scalars['String']['output'];
  src: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textFormat?: Maybe<Scalars['String']['output']>;
  ttsVersion?: Maybe<Scalars['String']['output']>;
  unviewedCommentCount?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionCoupon = {
  __typename?: 'SubscriptionCoupon';
  amount_off?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  percent_off?: Maybe<Scalars['Int']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type SubscriptionDiscount = {
  __typename?: 'SubscriptionDiscount';
  coupon?: Maybe<SubscriptionCoupon>;
  id?: Maybe<Scalars['ID']['output']>;
};

export enum SubscriptionInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  accessLimits: ProductAccessLimits;
  active: Scalars['Boolean']['output'];
  amount: Scalars['Int']['output'];
  auth0RoleId: Scalars['ID']['output'];
  currency: Scalars['String']['output'];
  discount?: Maybe<Array<Discount>>;
  displayInformation: SubscriptionPlanDisplayInformation;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  interval: SubscriptionInterval;
  intervalCount: Scalars['Int']['output'];
  isMultiSeat: Scalars['Boolean']['output'];
  isTrial: Scalars['Boolean']['output'];
  managed: Scalars['Boolean']['output'];
  productId: Scalars['ID']['output'];
  selectable: Scalars['Boolean']['output'];
  tier: SubscriptionPlanTier;
};


export type SubscriptionPlanDisplayInformationArgs = {
  inputs: SubscriptionPlansInputs;
};

export type SubscriptionPlanChangeTeamInputs = {
  seatCount: Scalars['Int']['input'];
  teamName?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionPlanDisplayInformation = {
  __typename?: 'SubscriptionPlanDisplayInformation';
  badgeLabel?: Maybe<Scalars['String']['output']>;
  discountLabel?: Maybe<Scalars['String']['output']>;
  displayActorCount: Scalars['Int']['output'];
  displayActorVariantCount: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  displayPrice: Scalars['String']['output'];
  displaySubheading: Scalars['String']['output'];
  displayTertiaryHeading: Scalars['String']['output'];
  lineItems: Array<SubscriptionPlanLineItems>;
  lineItemsHeader?: Maybe<Scalars['String']['output']>;
  lineItemsHeaderSecondary?: Maybe<Scalars['String']['output']>;
  lineItemsSecondary?: Maybe<Array<SubscriptionPlanLineItems>>;
};

export type SubscriptionPlanLineItems = {
  __typename?: 'SubscriptionPlanLineItems';
  emphasisLabel?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export enum SubscriptionPlanTier {
  Business = 'business',
  Creative = 'creative',
  Designer = 'designer',
  DesignerTrial = 'designer_trial',
  Enterprise = 'enterprise',
  Maker = 'maker',
  Producer = 'producer',
  Trial = 'trial'
}

export type SubscriptionPlansInputs = {
  via?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionProject = BaseProject & {
  __typename?: 'SubscriptionProject';
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  creatorId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shareable?: Maybe<ProjectShareable>;
  shareableUrl?: Maybe<Scalars['String']['output']>;
  studioVersion: StudioProjectVersion;
  updatedAt: Scalars['String']['output'];
};

export type SubscriptionProjectAccess = {
  __typename?: 'SubscriptionProjectAccess';
  id: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
  role?: Maybe<ProjectAccessRoleEnum>;
  sequence: Scalars['BigInt']['output'];
  teamId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
  TrialExpired = 'TRIAL_EXPIRED',
  Unpaid = 'UNPAID'
}

export enum SubscriptionTier {
  Creative = 'Creative',
  Designer = 'Designer',
  DesignerTrial = 'DesignerTrial',
  Maker = 'Maker',
  Producer = 'Producer',
  Team = 'Team',
  TeamEnterprise = 'TeamEnterprise',
  Trial = 'Trial'
}

export type SubscriptionUpdatePreview = {
  __typename?: 'SubscriptionUpdatePreview';
  amountDue: Scalars['Int']['output'];
  discount?: Maybe<Array<Discount>>;
  proration: SubscriptionUpdatePreviewAmount;
  /** @deprecated Use proration */
  prorationAmount: Scalars['Int']['output'];
  prorationDate: Scalars['Int']['output'];
  /** @deprecated Use remainingInPeriodExcludingTax */
  remainingAmountInPeriodExcludingTax: Scalars['Int']['output'];
  remainingInPeriodExcludingTax: SubscriptionUpdatePreviewAmount;
  tax?: Maybe<Scalars['Int']['output']>;
  totalExcludingTax?: Maybe<Scalars['Int']['output']>;
};

export type SubscriptionUpdatePreviewAmount = {
  __typename?: 'SubscriptionUpdatePreviewAmount';
  amount: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type SubscriptionUpdatePreviewInputs = {
  planId: Scalars['String']['input'];
  teamArgs?: InputMaybe<SubscriptionUpdatePreviewTeamInputs>;
};

export type SubscriptionUpdatePreviewTeamInputs = {
  seatCount: Scalars['Int']['input'];
};

export type SubscriptionUpgradeTeamInputs = {
  seatCount: Scalars['Int']['input'];
  teamName: Scalars['String']['input'];
};

export type TtsModelRelease = {
  __typename?: 'TTSModelRelease';
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  model: Scalars['String']['output'];
  /** @deprecated No longer needed. v10 out of service. */
  overrideSpeakerVariantId?: Maybe<Scalars['Int']['output']>;
  studioProjectVersion?: Maybe<StudioProjectVersion>;
};

export enum TtsVersionSelectOption {
  Latest = 'latest',
  Next = 'next',
  Previous = 'previous'
}

export type Take = {
  __typename?: 'Take';
  actor?: Maybe<TakeActor>;
  audioFormat: Scalars['String']['output'];
  avatarId: Scalars['Int']['output'];
  avatarVariantId: Scalars['Int']['output'];
  commentCount?: Maybe<Scalars['Int']['output']>;
  comments?: Maybe<ClipCommentsConnection>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  downloadedAt?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  /** 2 when stable editor state is stored on the take; otherwise 1 (legacy). */
  editorSchemaVersion: Scalars['Int']['output'];
  failedWithError?: Maybe<Scalars['String']['output']>;
  /**
   * Editor hydration source. When a stable `editor` column is populated, that
   * value is returned here; otherwise the TTS egress `formatted_text` column.
   */
  formattedText: Scalars['String']['output'];
  gcsFileName: Scalars['String']['output'];
  gcsUploadComplete?: Maybe<Scalars['Boolean']['output']>;
  hasCurrentUserFeedback?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use `gcsUploadComplete`. */
  isComplete?: Maybe<Scalars['Boolean']['output']>;
  isCreditableBy?: Maybe<Scalars['String']['output']>;
  isCurrentTake: Scalars['Boolean']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  localSrc?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sampleRate?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  streamRequest?: Maybe<Scalars['StreamRequest']['output']>;
  text: Scalars['String']['output'];
  textLength: Scalars['Int']['output'];
  ttsVersion: Scalars['String']['output'];
  unviewedCommentCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type TakeActor = {
  __typename?: 'TakeActor';
  id: Scalars['Int']['output'];
  image: Scalars['String']['output'];
  initials: Scalars['String']['output'];
  isCustomActor?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  ttsVersion?: Maybe<Scalars['String']['output']>;
  variant: ActorVariant;
};

export type TakeEdge = {
  __typename?: 'TakeEdge';
  cursor: Scalars['String']['output'];
  node: Take;
};

export type TakeFeedback = {
  __typename?: 'TakeFeedback';
  categories?: Maybe<Array<TakeFeedbackCategory>>;
  createdAt: Scalars['String']['output'];
  feedbackText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  positiveSentiment: Scalars['Boolean']['output'];
  takeId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export enum TakeFeedbackCategory {
  AwkwardBreathOrPause = 'awkward_breath_or_pause',
  CuesFailure = 'cues_failure',
  DigitalNoiseOrArtifact = 'digital_noise_or_artifact',
  Mispronunciation = 'mispronunciation',
  Other = 'other',
  UnnaturalDelivery = 'unnatural_delivery'
}

export type TakesConnection = {
  __typename?: 'TakesConnection';
  edges: Array<TakeEdge>;
  pageInfo: PageInfo;
};

export type TaxCalculation = {
  __typename?: 'TaxCalculation';
  amountDue: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  totalExcludingTax: Scalars['Int']['output'];
};

export type TaxId = {
  __typename?: 'TaxId';
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TaxIdInput = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Team = {
  __typename?: 'Team';
  /** Live agents of the team, oldest first. Team admins only; never API callers. */
  agents?: Maybe<Array<TeamAgent>>;
  companyName?: Maybe<Scalars['String']['output']>;
  dealId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitations: Array<UserInvitation>;
  managed: Scalars['Boolean']['output'];
  memberCount: Scalars['Int']['output'];
  members: Array<TeamMember>;
  productAccessLimits: ProductAccessLimits;
  productAccessPeriodUsage: ProductAccessPeriodUsage;
  seatCount: TeamSeatCount;
  settings: TeamSettings;
  ssoConnectionName?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<UserSubscription>;
  teamUserRoles: Array<TeamUserRole>;
  viewersRoleOnTeam?: Maybe<TeamRole>;
};

/**
 * An agent: a machine user of the team acting through its own client
 * credentials. Never carries the client secret (KTD20).
 */
export type TeamAgent = {
  __typename?: 'TeamAgent';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** `disabled_by_admin`, `owner_removed` or `deleted` when not active. */
  disabledReason?: Maybe<Scalars['String']['output']>;
  /** The agent's own Studio user id. */
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** The human member accountable for the agent; null when unresolvable. */
  owner?: Maybe<TeamMember>;
  ownerUserId?: Maybe<Scalars['ID']['output']>;
  /** Always `producer` (R6). */
  role: TeamRole;
  secretRotatedAt?: Maybe<Scalars['String']['output']>;
  state: TeamAgentState;
};

/**
 * Lifecycle of a team agent (U8, KTD13). Only `active` agents may act; every
 * other state is refused by the bearer agent guard.
 */
export enum TeamAgentState {
  Active = 'active',
  Disabled = 'disabled',
  Failed = 'failed',
  Provisioning = 'provisioning'
}

export type TeamAvatarSettings = {
  __typename?: 'TeamAvatarSettings';
  favoritedAt?: Maybe<Scalars['String']['output']>;
};

export enum TeamAvatarSettingsAction {
  Favorite = 'Favorite',
  Unfavorite = 'Unfavorite'
}

export type TeamMember = {
  __typename?: 'TeamMember';
  avatar?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initials: Scalars['String']['output'];
  /** True for an agent (a machine user with its own client credentials). */
  isAgent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  role: TeamRole;
};

export type TeamMemberAccess = {
  __typename?: 'TeamMemberAccess';
  id: Scalars['ID']['output'];
  projectAccessRole: ProjectAccessRole;
  projectId: Scalars['ID']['output'];
  teamId: Scalars['ID']['output'];
  teamMember: TeamMember;
};

export enum TeamRole {
  Admin = 'admin',
  Collaborator = 'collaborator',
  Owner = 'owner',
  Producer = 'producer'
}

export type TeamSeatCount = {
  __typename?: 'TeamSeatCount';
  id: Scalars['ID']['output'];
  paidSeatsTotal: Scalars['Int']['output'];
  paidSeatsUsed: Scalars['Int']['output'];
  roleQuotas: Array<Maybe<TeamSeatRoleQuota>>;
};

export type TeamSeatRoleQuota = {
  __typename?: 'TeamSeatRoleQuota';
  current: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type TeamSettings = {
  __typename?: 'TeamSettings';
  llmFeaturesEnabled: Scalars['Boolean']['output'];
};

export type TeamUserRole = {
  __typename?: 'TeamUserRole';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isQuota: Scalars['Boolean']['output'];
};

export type TeamUserRolePermission = {
  __typename?: 'TeamUserRolePermission';
  action: PermissionAction;
  feature: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
};

export type TokenizeScriptInputs = {
  script: Array<Scalars['String']['input']>;
};

export type TokenizeScriptMutationResponse = MutationResponse & {
  __typename?: 'TokenizeScriptMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tokens: Array<Array<Maybe<Scalars['String']['output']>>>;
};

export type TranslateProjectInputs = {
  driveId?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  sampleRate?: InputMaybe<Scalars['Int']['input']>;
  sectionSpecsInput: Array<SectionSpecInput>;
  studioVersion?: InputMaybe<StudioProjectVersion>;
  translationContext?: InputMaybe<LlmTranslationContext>;
};

export type TranslateProjectResponse = MutationResponse & {
  __typename?: 'TranslateProjectResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  projectSpec?: Maybe<ProjectSpec>;
  success: Scalars['Boolean']['output'];
};

export type Tutorial = {
  __typename?: 'Tutorial';
  category: Scalars['String']['output'];
  featuredImageSrc: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  src: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TutorialCta = {
  __typename?: 'TutorialCTA';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TutorialCategory = {
  __typename?: 'TutorialCategory';
  icon: TutorialIcon;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  type: TutorialType;
};

export type TutorialIcon = {
  __typename?: 'TutorialIcon';
  color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum TutorialType {
  Cues = 'cues',
  None = 'none',
  Pronunciation = 'pronunciation',
  Voices = 'voices',
  Workflow = 'workflow'
}

export type Tutorial_V2 = {
  __typename?: 'Tutorial_V2';
  body: Scalars['String']['output'];
  cta: TutorialCta;
  footer?: Maybe<Scalars['String']['output']>;
  header: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  type: TutorialType;
};

export type UndoCancelAddOnInputs = {
  addOnId: Scalars['ID']['input'];
};

export type UndoCancelAddOnMutationResponse = MutationResponse & {
  __typename?: 'UndoCancelAddOnMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<UserSubscription>;
  success: Scalars['Boolean']['output'];
};

export type UpdateAddressInfoMutationResponse = MutationResponse & {
  __typename?: 'UpdateAddressInfoMutationResponse';
  addressInfo?: Maybe<AddressInfo>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateBulkTeamMemberAccessInputs = {
  projectId: Scalars['String']['input'];
  /** role is either ProjectAccessRoleEnum or null; null will remove team members access */
  role?: InputMaybe<ProjectAccessRoleEnum>;
  teamId: Scalars['String']['input'];
  /** teamMemberIds include the ids of the users whose project access role will be updated */
  teamMemberIds: Array<Scalars['String']['input']>;
};

export type UpdateClipCommentInputs = {
  clipId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};

export type UpdateClipCommentMutationResponse = MutationResponse & {
  __typename?: 'UpdateClipCommentMutationResponse';
  code: Scalars['String']['output'];
  comment?: Maybe<ClipComment>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateClipInputs = {
  clipId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClipMutationResponse = MutationResponse & {
  __typename?: 'UpdateClipMutationResponse';
  clip?: Maybe<Clip>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateDriveInputs = {
  color?: InputMaybe<Scalars['String']['input']>;
  driveId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateDriveMutationResponse = MutationResponse & {
  __typename?: 'UpdateDriveMutationResponse';
  code: Scalars['String']['output'];
  drive?: Maybe<UserDrive>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateDriveUsersInputs = {
  driveId: Scalars['String']['input'];
  users: Array<DriveUserAccess>;
};

export type UpdateDriveUsersMutationResponse = MutationResponse & {
  __typename?: 'UpdateDriveUsersMutationResponse';
  code: Scalars['String']['output'];
  driveUsers?: Maybe<Array<Maybe<DriveUser>>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateEntitlementInputs = {
  /** Price in cents (Stripe unit_amount). */
  amount?: InputMaybe<Scalars['Int']['input']>;
  dataSource?: InputMaybe<Scalars['String']['input']>;
  dataSourceId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  featureIds?: InputMaybe<Array<Scalars['String']['input']>>;
  interval?: InputMaybe<Interval>;
  isManaged?: InputMaybe<Scalars['Boolean']['input']>;
  isMultiSeat?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EntitlementStatus>;
  tier?: InputMaybe<EntitlementTier>;
  type?: InputMaybe<EntitlementType>;
};

export type UpdateInvitationMutationResponse = MutationResponse & {
  __typename?: 'UpdateInvitationMutationResponse';
  code: Scalars['String']['output'];
  invitation?: Maybe<UserInvitation>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdatePaymentSourceInputs = {
  source: Scalars['String']['input'];
  subscriptionId: Scalars['ID']['input'];
};

export type UpdatePaymentSourceMutationResponse = MutationResponse & {
  __typename?: 'UpdatePaymentSourceMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<UserSubscription>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProjectAccessBulkTeamMemberAccessResponse = MutationResponse & {
  __typename?: 'UpdateProjectAccessBulkTeamMemberAccessResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role?: Maybe<ProjectAccessRole>;
  success: Scalars['Boolean']['output'];
  teamMemberIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateProjectAccessTeamMemberAccessResponse = MutationResponse & {
  __typename?: 'UpdateProjectAccessTeamMemberAccessResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role?: Maybe<ProjectAccessRole>;
  success: Scalars['Boolean']['output'];
  teamMemberId?: Maybe<Scalars['String']['output']>;
};

export type UpdateProjectAccessTeamWideAccessResponse = MutationResponse & {
  __typename?: 'UpdateProjectAccessTeamWideAccessResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  role?: Maybe<ProjectAccessRole>;
  success: Scalars['Boolean']['output'];
  teamMemberAccess?: Maybe<Array<TeamMemberAccess>>;
};

export type UpdateProjectDefaultPauseLengthInputs = {
  defaultPauseLength: Scalars['Int']['input'];
  projectId: Scalars['String']['input'];
};

export type UpdateProjectDefaultPauseLengthResponse = MutationResponse & {
  __typename?: 'UpdateProjectDefaultPauseLengthResponse';
  bulkPauseLength?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateProjectMutationResponse = MutationResponse & {
  __typename?: 'UpdateProjectMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  project?: Maybe<Project>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProjectVoicesInputs = {
  currentVariantId: Scalars['Int']['input'];
  defaultAvatarId: Scalars['Int']['input'];
  defaultAvatarVariantId: Scalars['Int']['input'];
  defaultTtsVersion?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};

export type UpdateProjectVoicesMutationResponse = MutationResponse & {
  __typename?: 'UpdateProjectVoicesMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  project?: Maybe<Project>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSectionCommentInputs = {
  commentId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  sectionId: Scalars['ID']['input'];
};

export type UpdateSectionCommentMutationResponse = MutationResponse & {
  __typename?: 'UpdateSectionCommentMutationResponse';
  code: Scalars['String']['output'];
  comment?: Maybe<SectionComment>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateSectionInputs = {
  defaultAvatarId?: InputMaybe<Scalars['Int']['input']>;
  defaultAvatarVariantId?: InputMaybe<Scalars['Int']['input']>;
  /** Omitted with a new avatar, the model resets to the variant's own version. */
  defaultTtsVersion?: InputMaybe<Scalars['String']['input']>;
  /** Stable editor schema; persisted to sections.editor when provided. */
  editor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSectionMutationResponse = MutationResponse & {
  __typename?: 'UpdateSectionMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  section?: Maybe<Section>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSectionNameInputs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateSectionNameMutationResponse = MutationResponse & {
  __typename?: 'UpdateSectionNameMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  section?: Maybe<Section>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSectionSequenceInputs = {
  followingSectionId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  precedingSectionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSectionSequenceMutationResponse = MutationResponse & {
  __typename?: 'UpdateSectionSequenceMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  section?: Maybe<Section>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSectionVoiceInputs = {
  defaultAvatarId: Scalars['Int']['input'];
  defaultAvatarVariantId: Scalars['Int']['input'];
  defaultTtsVersion?: InputMaybe<Scalars['String']['input']>;
  sectionId: Scalars['String']['input'];
};

export type UpdateSectionVoiceMutationResponse = MutationResponse & {
  __typename?: 'UpdateSectionVoiceMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  project?: Maybe<Project>;
  section?: Maybe<Section>;
  success: Scalars['Boolean']['output'];
};

export type UpdateSectionVoicesInputs = {
  sections: Array<SectionVoice>;
};

export type UpdateSectionVoicesMutationResponse = MutationResponse & {
  __typename?: 'UpdateSectionVoicesMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  projects?: Maybe<Array<Project>>;
  sections?: Maybe<Array<Section>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateTeamAgentInputs = {
  agentUserId: Scalars['ID']['input'];
  /** Explicit null clears the description; omit to leave it unchanged. */
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
  teamId: Scalars['ID']['input'];
};

export type UpdateTeamAgentPayload = MutationResponse & {
  __typename?: 'UpdateTeamAgentPayload';
  agent?: Maybe<TeamAgent>;
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateTeamAvatarSettingsInputs = {
  action: TeamAvatarSettingsAction;
  avatarId: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamAvatarSettingsMutationResponse = MutationResponse & {
  __typename?: 'UpdateTeamAvatarSettingsMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateTeamMemberAccessInputs = {
  projectId: Scalars['String']['input'];
  /** role is either ProjectAccessRoleEnum or null; null will remove team member access */
  role?: InputMaybe<ProjectAccessRoleEnum>;
  teamId: Scalars['String']['input'];
  /** teamMemberId is the id of the user whose project access role will be updated */
  teamMemberId: Scalars['String']['input'];
};

export type UpdateTeamMemberInputs = {
  memberId: Scalars['ID']['input'];
  role: TeamRole;
  teamId: Scalars['ID']['input'];
};

export type UpdateTeamMemberMutationResponse = MutationResponse & {
  __typename?: 'UpdateTeamMemberMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  teamMember?: Maybe<TeamMember>;
};

export type UpdateTeamSettingsInputs = {
  llmFeaturesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['ID']['input'];
};

export type UpdateTeamSettingsResponse = MutationResponse & {
  __typename?: 'UpdateTeamSettingsResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  settings?: Maybe<TeamSettings>;
  success: Scalars['Boolean']['output'];
};

export type UpdateTeamUserInvitationInputs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  teamId: Scalars['ID']['input'];
  teamRole: TeamRole;
};

export type UpdateTeamWideAccessInputs = {
  projectId: Scalars['String']['input'];
  /** role is either ProjectAccessRoleEnum or null; null will remove team wide access */
  role?: InputMaybe<ProjectAccessRoleEnum>;
  teamId: Scalars['String']['input'];
};

export type UpdateUserAuthMethodInputs = {
  email: Scalars['String']['input'];
  identities?: InputMaybe<Array<Identity>>;
  userId: Scalars['String']['input'];
};

export type UpdateUserAuthMethodsMutationResponse = MutationResponse & {
  __typename?: 'UpdateUserAuthMethodsMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  userAuthMethods: Array<UserAuthMethod>;
};

export type UpdateUserAvatarSettingsInputs = {
  action: UserAvatarSettingsAction;
  avatarId: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserAvatarSettingsMutationResponse = MutationResponse & {
  __typename?: 'UpdateUserAvatarSettingsMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateUserProfileInputs = {
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfileMutationResponse = MutationResponse & {
  __typename?: 'UpdateUserProfileMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  profile?: Maybe<Profile>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserSelectionsInputs = {
  selections: Array<UserSelection>;
};

export type UpdateUserSelectionsResponse = MutationResponse & {
  __typename?: 'UpdateUserSelectionsResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  selections?: Maybe<Array<Maybe<UserSelectionType>>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateUserSettingsInputs = {
  defaultTTSVersion?: InputMaybe<TtsVersionSelectOption>;
  displayTTSVersionSelector?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated not in use */
  doNotShowClipDeletionConfirmationModal?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated not in use */
  doNotShowClipPreviewDeletionConfirmationModal?: InputMaybe<Scalars['Boolean']['input']>;
  doNotShowDeleteTeamReplacementConfirmationModal?: InputMaybe<Scalars['Boolean']['input']>;
  doNotShowNavigationConfirmationModal?: InputMaybe<Scalars['Boolean']['input']>;
  globalAudioFileFormat?: InputMaybe<AudioFileFormat>;
  globalAudioFileFormatSelected?: InputMaybe<Scalars['Boolean']['input']>;
  globalAudioPlaybackSetting?: InputMaybe<AudioPlaybackSetting>;
  includeClipScriptFormats?: InputMaybe<Array<ScriptFormat>>;
};

export type UpdateUserSettingsResponse = MutationResponse & {
  __typename?: 'UpdateUserSettingsResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  settings?: Maybe<UserSettings>;
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  abilities: Scalars['String']['output'];
  /** FilterAndSearchAvatarsInputs is optional because excluding it returns all Actors */
  actors: Array<Actor>;
  /** @deprecated Announcements are no longer served. This field returns an empty list and will be removed. */
  announcements: Array<Announcement>;
  apiCharacterUsage?: Maybe<Scalars['Int']['output']>;
  apiSubscriptions: Array<Maybe<ApiSubscription>>;
  billingHistory: Array<BillingHistory>;
  clipsGenerated: Scalars['Int']['output'];
  clipsMetrics: ClipsMetrics;
  contact?: Maybe<UserContact>;
  drives?: Maybe<Array<UserDrive>>;
  flags: Array<Scalars['String']['output']>;
  folders?: Maybe<Array<Folder>>;
  hasAcceptedTerms: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isCustomVoiceOnlySubscription?: Maybe<Scalars['Boolean']['output']>;
  isRBACEnabled: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  pendingTeamInvitation?: Maybe<UserInvitation>;
  permissions: Array<Scalars['String']['output']>;
  personalProjects: ProjectsConnection;
  phoneticLibrary: PhoneticLibrary;
  productAccessLimits: ProductAccessLimits;
  productAccessPeriodUsage: ProductAccessPeriodUsage;
  profile: Profile;
  project?: Maybe<Project>;
  /**
   * Every project this user can reach whose name or client name matches, across
   * personal, team and custom drives, nested folders and team sharing. No drive
   * or folder is required.
   */
  projectSearch: ProjectSearchConnection;
  roles: Array<Role>;
  selections: Array<UserSelectionType>;
  settings: UserSettings;
  sharedProjects: ProjectsConnection;
  studioProjectVersions: Array<StudioProjectVersion>;
  subscription?: Maybe<UserSubscription>;
  subscriptionPlans: Array<SubscriptionPlan>;
  subscriptionUpdatePreview?: Maybe<SubscriptionUpdatePreview>;
  suggestedProjects: ProjectsConnection;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['ID']['output']>;
  teamProjects: ProjectsConnection;
  workspaceProjects: ProjectsConnection;
};


export type UserActorsArgs = {
  inputs?: InputMaybe<FilterAndSearchAvatarsInputs>;
};


export type UserDrivesArgs = {
  inputs?: InputMaybe<DrivesInputs>;
};


export type UserFoldersArgs = {
  inputs: FolderInputs;
};


export type UserPersonalProjectsArgs = {
  inputs: ProjectInputs;
};


export type UserProjectArgs = {
  inputs: UserProjectInputs;
};


export type UserProjectSearchArgs = {
  inputs: ProjectSearchInputs;
};


export type UserSharedProjectsArgs = {
  inputs: ProjectInputs;
};


export type UserSubscriptionPlansArgs = {
  inputs: SubscriptionPlansInputs;
};


export type UserSubscriptionUpdatePreviewArgs = {
  inputs: SubscriptionUpdatePreviewInputs;
};


export type UserTeamProjectsArgs = {
  inputs: ProjectInputs;
};


export type UserWorkspaceProjectsArgs = {
  inputs: ProjectInputs;
};

export type UserAuthMethod = {
  __typename?: 'UserAuthMethod';
  connectionDisplay: ConnectionDisplay;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSocial: Scalars['Boolean']['output'];
  provider: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserAvatarSettings = {
  __typename?: 'UserAvatarSettings';
  favoritedAt?: Maybe<Scalars['String']['output']>;
  hiddenAt?: Maybe<Scalars['String']['output']>;
};

export enum UserAvatarSettingsAction {
  Favorite = 'Favorite',
  Hide = 'Hide',
  Unfavorite = 'Unfavorite',
  Unhide = 'Unhide'
}

export type UserContact = {
  __typename?: 'UserContact';
  companyName?: Maybe<Scalars['String']['output']>;
  hasRequestedTrialApiKey: Scalars['Boolean']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type UserDrive = Drive & {
  __typename?: 'UserDrive';
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  driveAccess: DriveAccessRole;
  driveType: DriveTypeFromDb;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  settings?: Maybe<DriveSettings>;
  teamId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['String']['output'];
};

export enum UserIntegrationType {
  AdobeExpress = 'adobe_express',
  AdobePremiere = 'adobe_premiere',
  Canva = 'canva'
}

export type UserInvitation = {
  __typename?: 'UserInvitation';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitationCode: Scalars['String']['output'];
  invitationStatus: UserInvitationStatus;
  lastName?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  teamId?: Maybe<Scalars['ID']['output']>;
  teamRole?: Maybe<TeamRole>;
  updatedAt: Scalars['String']['output'];
};

export type UserInvitationInputs = {
  email?: InputMaybe<Scalars['String']['input']>;
  invitationCode?: InputMaybe<Scalars['String']['input']>;
};

export enum UserInvitationStatus {
  Accepted = 'accepted',
  Expired = 'expired',
  Pending = 'pending'
}

export type UserProjectInputs = {
  projectId: Scalars['ID']['input'];
};

export type UserReplacements = {
  __typename?: 'UserReplacements';
  personal?: Maybe<Array<Maybe<PhoneticReplacement>>>;
  team?: Maybe<Array<Maybe<PhoneticReplacement>>>;
};

export type UserSelection = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UserSelectionType = {
  __typename?: 'UserSelectionType';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  defaultTTSVersion?: Maybe<TtsVersionSelectOption>;
  displayTTSVersionSelector?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not in use */
  doNotShowClipDeletionConfirmationModal?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated not in use */
  doNotShowClipPreviewDeletionConfirmationModal?: Maybe<Scalars['Boolean']['output']>;
  doNotShowDeleteTeamReplacementConfirmationModal?: Maybe<Scalars['Boolean']['output']>;
  doNotShowNavigationConfirmationModal?: Maybe<Scalars['Boolean']['output']>;
  globalAudioFileFormat?: Maybe<AudioFileFormat>;
  globalAudioFileFormatSelected?: Maybe<Scalars['Boolean']['output']>;
  globalAudioPlaybackSetting?: Maybe<AudioPlaybackSetting>;
  includeClipScriptFormats?: Maybe<Array<ScriptFormat>>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  addOns: Array<SubscriptionAddOn>;
  billing?: Maybe<SubscriptionBilling>;
  billingHistory?: Maybe<Array<BillingHistory>>;
  cancelAt?: Maybe<Scalars['Int']['output']>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['Int']['output']>;
  churnkeyAuthHash?: Maybe<Scalars['String']['output']>;
  created: Scalars['Int']['output'];
  currentPeriodEnd: Scalars['Int']['output'];
  currentPeriodStart: Scalars['Int']['output'];
  customerId: Scalars['ID']['output'];
  discount?: Maybe<SubscriptionDiscount>;
  id: Scalars['ID']['output'];
  isTeamSubscription: Scalars['Boolean']['output'];
  plan: SubscriptionPlan;
  seatCount: Scalars['Int']['output'];
  status: SubscriptionStatus;
};

export type UserSubscriptionCancelMutationRespnse = MutationResponse & {
  __typename?: 'UserSubscriptionCancelMutationRespnse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<UserSubscription>;
  success: Scalars['Boolean']['output'];
};

export type UserSubscriptionPlanChangeInputs = {
  addressInfo?: InputMaybe<AddressInfoInputs>;
  paymentSource?: InputMaybe<Scalars['String']['input']>;
  prorationDate: Scalars['Int']['input'];
  subscriptionPlanId: Scalars['ID']['input'];
  teamArgs?: InputMaybe<SubscriptionPlanChangeTeamInputs>;
};

export type UserSubscriptionPlanChangeMutationResponse = MutationResponse & {
  __typename?: 'UserSubscriptionPlanChangeMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<UserSubscription>;
  success: Scalars['Boolean']['output'];
  teamProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  userProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
};

export type UserSubscriptionUndoCancellationInputs = {
  subscriptionId: Scalars['ID']['input'];
};

export type UserSubscriptionUndoCancellationMutationResponse = MutationResponse & {
  __typename?: 'UserSubscriptionUndoCancellationMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<UserSubscription>;
  success: Scalars['Boolean']['output'];
};

export type UserSubscriptionUpgradeInputs = {
  addressInfo?: InputMaybe<AddressInfoInputs>;
  paymentSource?: InputMaybe<Scalars['String']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  subscriptionPlanId: Scalars['ID']['input'];
  teamArgs?: InputMaybe<SubscriptionUpgradeTeamInputs>;
};

export type UserSubscriptionUpgradeMutationResponse = MutationResponse & {
  __typename?: 'UserSubscriptionUpgradeMutationResponse';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subscription?: Maybe<UserSubscription>;
  success: Scalars['Boolean']['output'];
  teamProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
  userProductAccessPeriodUsage?: Maybe<ProductAccessPeriodUsage>;
};

export type ValidateAndCorrectProjectAccessData = {
  __typename?: 'ValidateAndCorrectProjectAccessData';
  projectsCorrected?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  teamId?: Maybe<Scalars['String']['output']>;
};

export type ValidateAndCorrectProjectAccessInputs = {
  teamIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ValidateAndCorrectProjectAccessMutationResponse = MutationResponse & {
  __typename?: 'ValidateAndCorrectProjectAccessMutationResponse';
  code: Scalars['String']['output'];
  data?: Maybe<Array<Maybe<ValidateAndCorrectProjectAccessData>>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum ProductAccessUsageScope {
  Team = 'Team',
  User = 'User'
}

export type RespellingSuggestion = {
  __typename?: 'respellingSuggestion';
  respelling: Scalars['String']['output'];
  word: Scalars['String']['output'];
};

export type RespellingSuggestionsByRegion = {
  __typename?: 'respellingSuggestionsByRegion';
  uk: Array<RespellingSuggestion>;
  us: Array<RespellingSuggestion>;
};

export type RespellingSuggestionsInputs = {
  word: Scalars['String']['input'];
};
